<template>
  <div>
    <div class="top-info">
      <div class="fl">
        <h4 class="heading-top-info" :data-track="widgetsProperties.title"> {{ widgetsProperties.title}} </h4>
      </div>
      <div class="fr">
        <a target="_blank" :href="aboutFeatureLink"><img
          src="/static/img/dummy-help.png"/><span>About this feature</span></a>
      </div>
    </div>

    <div class="widgets-list ">
      <div class="structure mt-20">
        <div class="columns">

          <div class="main-container" v-if="currentWidget === 'topReviews'">
            <div class="md6">
              <div class="left-side-container">
                <h3 class="heading-main heading-main-top" data-track="View Review Feed widget detail page">Review
                  feed</h3>
                <p class="paragrph-style">A vertical feed that shows your latest 4 and 5-star reviews. Potential
                  consumers will be able to see why deciding on your business is a great choice to make.

                </p>
                <div class="dimension-wrapper dimension_box_first">
                  <h4>
                    Dimensions
                  </h4>
                  <p class="paragrph-style">Desktop : 322 x 598px </p>
                  <p class="paragrph-style">Mobile : 242 x 562px </p>
                </div>
                <div class="dimension-wrapper dimension_html_box">
                  <h4>
                    HTML code
                  </h4>
                  <p>Display your key Hellopeter metrics on your website by adding the code snippets into your website's
                    HTML.</p>
                  <div class="dimension-wrapper">
                    <p class="codeblock" v-text="reviewFeedCodeBlock"></p>
                  </div>
                  <button :data-track="widgetsProperties.title" href="javascript:void(0);"
                          @click="copyLink(reviewFeedCodeBlock)" :class="[{'disable-link':showDummyReview}]">Copy Code
                  </button>
                </div>
              </div>
            </div>
            <div class="md4">
              <!--Add info box when review data not found -->
              <div v-if="showDummyReview"><img src="/static/img/widgets/Group-526.png"
                                               srcset="/static/Group-526@2x.png 2x, /static/Group-526@3x.png 3x"
                                               class="Group-526"></div>
              <!--End review info box -->
              <div class="right-side-container preview_mainsection">
                <div class="header">
                  <p>Preview</p>
                  <h6 class="is-size-7 icon-container title-business responsive-action noselect">
                    <span class="desktop-icon"
                          v-on="isActive ? { click: () => responsive('desktop') } : {click: ($event) => $event.preventDefault() }"
                          :class="{ 'has-text-weight-bold active': !isActive }"> <img class="ds1"
                                                                                      src="/static/img/desktop-icon-grey1.png">  <img
                      class="ds2" src="/static/img/desktop-icon-white.png"> </span>
                    <span class="mob-icon"
                          v-on="!isActive ? { click: () => responsive('mobile') } : {click: ($event) => $event.preventDefault() }"
                          :class="{ 'has-text-weight-bold active': isActive }">&nbsp;<img class="mb1"
                                                                                          src="/static/img/mobile-icon-grey.png"> <img
                      class="mb2" src="/static/img/mobile-icon-white.png"></span>
                  </h6>
                </div>
                <div class="preview-com vertical-30" :class="previewWidth" ref="star">
                  <div class="preview_white_bg review_top_slider">
                    <review-vertical :slug="businessSlug" :clickLink="showDummyReview"></review-vertical>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="main-container-full review_slider " v-if="currentWidget === 'carousel-old'">
            <div class="full-width">
              <h3 class="heading-main heading-main-top" data-track="View Collect Reviews carousel detail page">Collect
                reviews carousel</h3>
              <p class="paragrph-style">Allow your consumers to swipe through your most recent positive reviews. This
                Widget is a great way to let your great work shine.
              </p>
              <!--Add img when review data not found -->
              <div class="carousel-dummy-text" v-if="showDummyReview">
                <p> The current widget displayed is <b>an example for demonstration purposes</b> only.
                  The widget example will be updated with your business's data when you have collected your first
                  review.</p>
              </div>
              <!--End review img div -->
            </div>
            <div class="full-width">
              <div class="right-side-container">
                <div class="header">
                  <p>Preview</p>
                  <h6 class="is-size-7 icon-container title-business responsive-action noselect">
                    <span class="desktop-icon"
                          v-on="isActive ? { click: () => responsiveCarousel('desktop') } : {click: ($event) => $event.preventDefault() }"
                          :class="{ 'has-text-weight-bold active': !isActive }"> <img class="ds1"
                                                                                      src="/static/img/desktop-icon-grey1.png">  <img
                      class="ds2" src="/static/img/desktop-icon-white.png"> </span>
                    <span class="mob-icon"
                          v-on="!isActive ? { click: () => responsiveCarousel('mobile') } : {click: ($event) => $event.preventDefault() }"
                          :class="{ 'has-text-weight-bold active': isActive }">&nbsp;<img class="mb1"
                                                                                          src="/static/img/mobile-icon-grey.png"> <img
                      class="mb2" src="/static/img/mobile-icon-white.png"></span>
                  </h6>
                </div>
                <div class="preview-com " :class="previewWidthPercent" ref="star">
                  <div class="preview_white_bg">
                    <review-carousel :slug="businessSlug" :reviewsPerPage="slidesPerPage"></review-carousel>
                  </div>
                </div>
              </div>
            </div>

            <div class="full-width">
              <div class="left-side-container">
                <div class="dimension-wrapper ">
                  <h4>
                    Dimensions
                  </h4>
                  <p class="paragrph-style">Widget dimensions are 723 x 226px </p>
                </div>
                <div class="dimension-wrapper ">
                  <h4>
                    HTML code
                  </h4>
                  <p>Display your key Hellopeter metrics on your website by adding the code snippets into your website's
                    HTML</p>
                  <div class="dimension-wrapper ">
                    <p class="codeblock" v-text="reviewCarouselCodeBlock"></p>
                  </div>
                  <button :data-track="widgetsProperties.title" href="javascript:void(0);"
                          @click="copyLink(reviewCarouselCodeBlock)" :class="[{'disable-link':showDummyReview}]">Copy
                    Code
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="main-container" v-if="currentWidget == 'reviewTab'">
            <div class="md6">
              <div class="left-side-container">
                <p class="paragrph-style"> {{ widgetsProperties.short_description}}</p>
                <div v-for="property in widgetsProperties.properties"
                     :class="['dimension-wrapper ', [property.prop_class]]">
                  <h4>{{ property.prop_title }}</h4>
                  <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                  <div :class="['prop_container', [prop.prop_class]]" v-for="prop in property.prop_option ">
                    <p v-if="prop.title" class="paragrph-style">{{ prop.title}}</p>
                    <div :class="options.class" v-for="options in prop.options">
                      <div class="field fields" v-if="options.type == 'radio' ">
                        <input :value="options.value" type="radio" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'checkbox'">
                        <input :value="options.value" type="checkbox" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                      </div>

                      <div class="field" v-if="options.type == 'select'">
                        <div class="control" :class="options.id">
                          <div class="select is-info">
                            <select :id="options.id" :name="options.name"
                                    v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input">
                              <option v-for="item in options.values" :value="item.value"> {{ item.text}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="field" v-if="options.type == 'textarea'">
                        <textarea :class="options.class" :id="options.id"
                                  v-model.trim="widgetConfig[currentWidget][options.name]"
                                  v-show="options.display_input"
                                  :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                        <p class="notice_max_char" v-if="options.maxLength"> Max {{ options.maxLength}} Characters</p>
                      </div>
                      <div class="field" v-if="options.type == 'color'">
                        <verte :id="options.id" position="left" picker="square" :showHistory="false"
                               v-model.trim="widgetConfig[currentWidget][options.name]" model="hex">
                        </verte>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                      </div>
                      <div class="field star-rating-container" v-if="options.type === 'star-rating'">
                        <verte :id="options.id" position="left"
                               v-model="widgetConfig[currentWidget][options.name]" picker="square" :showHistory="false"
                               v-model.trim="widgetConfig[currentWidget][options.name]" model="hex"></verte>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        <div class="stars"><span class="fa fa-star" v-for="index in 5"
                                                 v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                        </div>
                        <label :for="options.id">{{ options.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dimension-wrapper" id="codeblock-container">
                  <p id="codeblock" class="codeblock" :disabled="showDummyReviewRatingTab" v-text="reviewTabCodeBlock"></p>
                </div>
                <div class="dimension-wrapper dimension_html_box" style="min-height: 16px; margin-bottom:40px">
                  <button :data-track="widgetsProperties.title" @click="copyLink(reviewTabCodeBlock)"
                          href="javascript:void(0)" :disabled="showDummyReviewRatingTab" :class="['is-pulled-right button']">
                    Copy Code
                  </button>
                </div>
              </div>
            </div>
            <div class="md4">
              <preview-widget :myprops="widgetConfig[currentWidget]"></preview-widget>
            </div>
          </div>

          <div class="main-container" v-if="currentWidget == 'reviewBadge'">
            <div class="md6">
              <div class="left-side-container">
                <p class="paragrph-style">{{ widgetsProperties.short_description}} </p>
                <div v-for="property in widgetsProperties.properties"
                     :class="['dimension-wrapper ', [property.prop_class]]">
                  <h4>{{ property.prop_title }}</h4>
                  <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                  <div :class="['prop_container', [prop.prop_class]]" v-for="prop in property.prop_option ">
                    <p v-if="prop.title" class="paragrph-style">{{ prop.title}}</p>
                    <div :class="options.class" v-for="options in prop.options">

                      <div class="field" v-if="options.type == 'radio' ">
                        <input :value="options.value" type="radio" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                        <label class="sub_label" v-if="options.sub_label">{{ options.sub_label }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'checkbox'">
                        <input :value="options.value" type="checkbox" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                      </div>

                      <div class="field" v-if="options.type == 'radio_img'">
                        <input type="radio" :value="options.value" :id="options.id" :name="options.name"
                               :disabled="!isLogoEnabled" v-model="widgetConfig[currentWidget][options.name]"
                               v-show="options.display_input"
                               :class="['is-checkradio', 'has-background-color', 'is-info', !isLogoEnabled ? 'disabled': '']">
                        <label :for="options.id"><span class="img_radio"><img :src="options.img_src"
                                                                              :class="options.class"/></span></label>
                      </div>

                      <div class="field" v-if="options.type == 'select'">
                        <div class="control" :class="options.id">
                          <div class="select is-info">
                            <select :id="options.id" :name="options.name"
                                    v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input">
                              <option v-for="item in options.values" :value="item.value"> {{ item.text}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="field" v-if="options.type == 'textarea'">
                        <textarea :class="options.class" :id="options.id"
                                  v-model.trim="widgetConfig[currentWidget][options.name]"
                                  v-show="options.display_input"
                                  :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                        <p class="notice_max_char" v-if="options.maxLength"> Max {{ options.maxLength}} Characters</p>
                      </div>
                      <div class="field " v-if="options.type == 'color'">
                        <verte v-if="!hideFontColor" :id="options.id" position="left" picker="square"
                               :showHistory="false" v-model.trim="widgetConfig[currentWidget][options.name]"
                               model="hex">
                        </verte>
                        <div v-show="hideFontColor" id="dummy_color_picker"/>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'download_link'">
                        <img class="download_img" src="/static/img/download-icon.png">
                        <a :class="options.class" @click.prevent="handle_function_call(options.clk)"
                           href="#">Download</a>
                      </div>
                      <div class="field star-rating-container" v-if="options.type === 'star-rating'">
                        <verte :id="options.id" position="left"
                               v-model="widgetConfig[currentWidget][options.name]" picker="square" :showHistory="false"
                               v-model.trim="widgetConfig[currentWidget][options.name]" model="hex"></verte>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        <div class="stars"><span class="fa fa-star" v-for="index in 5"
                                                 v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                        </div>
                        <label :for="options.id">{{ options.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dimension-wrapper" id="codeblock-container">
                  <p id="codeblock" class="codeblock" :disabled="showDummyReview" v-text="reviewBadgeCodeBlock"></p>
                </div>
                <div class="dimension-wrapper dimension_html_box" style="min-height: 16px; margin-bottom:40px">
                  <button :data-track="widgetsProperties.title" @click="copyLink(reviewBadgeCodeBlock)"
                          href="javascript:void(0)" :disabled="showDummyReview" :class="['is-pulled-right button']">
                    Copy Code
                  </button>
                </div>
              </div>
            </div>
            <div class="md4 verified_review_badge_container">
              <preview-widget :myprops="widgetConfig[currentWidget]" ref="verifiedBadge"></preview-widget>
            </div>
          </div>

          <div class="main-container" v-if="currentWidget == 'verifiedSiteBadge'">
            <div class="md6">
              <div class="left-side-container">
                <p class="paragrph-style">{{ widgetsProperties.short_description}} </p>
                <div v-for="property in widgetsProperties.properties"
                     :class="['dimension-wrapper ', [property.prop_class]]">
                  <h4>{{ property.prop_title }}</h4>
                  <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                  <div :class="['prop_container', [prop.prop_class]]" v-for="prop in property.prop_option ">
                    <p v-if="prop.title" class="paragrph-style">{{ prop.title}}</p>
                    <div :class="options.class" v-for="options in prop.options">

                      <div class="field" v-if="options.type == 'radio' ">
                        <input :value="options.value" type="radio" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                        <label class="sub_label" v-if="options.sub_label">{{ options.sub_label }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'checkbox'">
                        <input :value="options.value" type="checkbox" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                      </div>

                      <div class="field" v-if="options.type == 'radio_img'">
                        <input type="radio" :value="options.value" :id="options.id" :name="options.name"
                               :disabled="!isLogoEnabled" v-model="widgetConfig[currentWidget][options.name]"
                               v-show="options.display_input"
                               :class="['is-checkradio', 'has-background-color', 'is-info', !isLogoEnabled ? 'disabled': '']">
                        <label :for="options.id"><span class="img_radio"><img :src="options.img_src"
                                                                              :class="options.class"/></span></label>
                      </div>

                      <div class="field" v-if="options.type == 'select'">
                        <div class="control" :class="options.id">
                          <div class="select is-info">
                            <select :id="options.id" :name="options.name"
                                    v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input">
                              <option v-for="item in options.values" :value="item.value"> {{ item.text}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="field" v-if="options.type == 'textarea'">
                        <textarea :class="options.class" :id="options.id"
                                  v-model.trim="widgetConfig[currentWidget][options.name]"
                                  v-show="options.display_input"
                                  :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                        <p class="notice_max_char" v-if="options.maxLength"> Max {{ options.maxLength}} Characters</p>
                      </div>
                      <div class="field " v-if="options.type == 'color'">
                        <verte v-if="!hideFontColor" :id="options.id" position="left" picker="square"
                               :showHistory="false" v-model.trim="widgetConfig[currentWidget][options.name]"
                               model="hex">
                        </verte>
                        <div v-show="hideFontColor" id="dummy_color_picker"/>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'download_link'">
                        <img class="download_img" src="/static/img/download-icon.png">
                        <a :class="options.class" @click.prevent="handle_function_call(options.clk)"
                           href="#">Download</a>
                      </div>
                      <div class="field star-rating-container" v-if="options.type === 'star-rating'">
                        <verte :id="options.id" position="left"
                               v-model="widgetConfig[currentWidget][options.name]" picker="square" :showHistory="false"
                               v-model.trim="widgetConfig[currentWidget][options.name]" model="hex"></verte>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        <div class="stars"><span class="fa fa-star" v-for="index in 5"
                                                 v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                        </div>
                        <label :for="options.id">{{ options.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dimension-wrapper" id="codeblock-container">
                  <p id="codeblock" class="codeblock" :disabled="showDummyReview" v-text="verifiedSiteBadgeCodeBlock"></p>
                </div>
                <div class="dimension-wrapper dimension_html_box" style="min-height: 16px; margin-bottom:40px">
                  <button :data-track="widgetsProperties.title" @click="copyLink(verifiedSiteBadgeCodeBlock)"
                          href="javascript:void(0)" :disabled="showDummyReview" :class="['is-pulled-right button']">
                    Copy Code
                  </button>
                </div>
              </div>
            </div>
            <div class="md4 verified_review_badge_container">
              <preview-widget :myprops="widgetConfig[currentWidget]" ref="verifiedBadge"></preview-widget>
            </div>
          </div>

          <div class="main-container" v-if="currentWidget == 'ribbonBadge'">
            <div class="md6">
              <div class="left-side-container">
                <p class="paragrph-style">{{ widgetsProperties.short_description}} </p>
                <div v-for="property in widgetsProperties.properties"
                     :class="['dimension-wrapper ', [property.prop_class]]">
                  <h4>{{ property.prop_title }}</h4>
                  <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                  <div :class="['prop_container', [prop.prop_class]]" v-for="prop in property.prop_option ">
                    <p v-if="prop.title" class="paragrph-style">{{ prop.title}}</p>
                    <div :class="options.class" v-for="options in prop.options">

                      <div class="field" v-if="options.type == 'radio' ">
                        <input :value="options.value" type="radio" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                        <label class="sub_label" v-if="options.sub_label">{{ options.sub_label }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'checkbox'">
                        <input :value="options.value" type="checkbox" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                      </div>

                      <div class="field" v-if="options.type == 'radio_img'">
                        <input type="radio" :value="options.value" :id="options.id" :name="options.name"
                               :disabled="!isLogoEnabled" v-model="widgetConfig[currentWidget][options.name]"
                               v-show="options.display_input"
                               :class="['is-checkradio', 'has-background-color', 'is-info', !isLogoEnabled ? 'disabled': '']">
                        <label :for="options.id"><span class="img_radio"><img :src="options.img_src"
                                                                              :class="options.class"/></span></label>
                      </div>

                      <div class="field" v-if="options.type == 'select'">
                        <div class="control" :class="options.id">
                          <div class="select is-info">
                            <select :id="options.id" :name="options.name"
                                    v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input">
                              <option v-for="item in options.values" :value="item.value"> {{ item.text}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="field" v-if="options.type == 'textarea'">
                        <textarea :class="options.class" :id="options.id"
                                  v-model.trim="widgetConfig[currentWidget][options.name]"
                                  v-show="options.display_input"
                                  :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                        <p class="notice_max_char" v-if="options.maxLength"> Max {{ options.maxLength}} Characters</p>
                      </div>
                      <div class="field " v-if="options.type == 'color'">
                        <verte v-if="!hideFontColor" :id="options.id" position="left" picker="square"
                               :showHistory="false" v-model.trim="widgetConfig[currentWidget][options.name]"
                               model="hex">
                        </verte>
                        <div v-show="hideFontColor" id="dummy_color_picker"/>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'download_link'">
                        <img class="download_img" src="/static/img/download-icon.png">
                        <a :class="options.class" @click.prevent="handle_function_call(options.clk)"
                           href="#">Download</a>
                      </div>
                      <div class="field star-rating-container" v-if="options.type === 'star-rating'">
                        <verte :id="options.id" position="left"
                               v-model="widgetConfig[currentWidget][options.name]" picker="square" :showHistory="false"
                               v-model.trim="widgetConfig[currentWidget][options.name]" model="hex"></verte>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        <div class="stars"><span class="fa fa-star" v-for="index in 5"
                                                 v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                        </div>
                        <label :for="options.id">{{ options.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dimension-wrapper" id="codeblock-container">
                  <p id="codeblock" class="codeblock" :disabled="showDummyReview" v-text="ribbonBadgeCodeBlock"></p>
                </div>
                <div class="dimension-wrapper dimension_html_box" style="min-height: 16px; margin-bottom:40px">
                  <button :data-track="widgetsProperties.title" @click="copyLink(ribbonBadgeCodeBlock)"
                          href="javascript:void(0)" :disabled="showDummyReview" :class="['is-pulled-right button']">
                    Copy Code
                  </button>
                </div>
              </div>
            </div>
            <div class="md4 verified_review_badge_container">
              <preview-widget :myprops="widgetConfig[currentWidget]" ref="verifiedBadge"></preview-widget>
            </div>
          </div>

          <div class="main-container" v-if="currentWidget == 'metricDisplayBadge'">
            <div class="md6">
              <div class="left-side-container">
                <p class="paragrph-style">{{ widgetsProperties.short_description}} </p>
                <div v-for="property in widgetsProperties.properties"
                     :class="['dimension-wrapper ', [property.prop_class]]">
                  <h4>{{ property.prop_title }}</h4>
                  <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                  <div :class="['prop_container', [prop.prop_class]]" v-for="prop in property.prop_option ">
                    <p v-if="prop.title" class="paragrph-style">{{ prop.title}}</p>
                    <div :class="options.class" v-for="options in prop.options">

                      <div class="field" v-if="options.type == 'radio' ">
                        <input :value="options.value" type="radio" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                        <label class="sub_label" v-if="options.sub_label">{{ options.sub_label }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'checkbox'">
                        <input :value="options.value" type="checkbox" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                      </div>

                      <div class="field" v-if="options.type == 'radio_img'">
                        <input type="radio" :value="options.value" :id="options.id" :name="options.name"
                               :disabled="!isLogoEnabled" v-model="widgetConfig[currentWidget][options.name]"
                               v-show="options.display_input"
                               :class="['is-checkradio', 'has-background-color', 'is-info', !isLogoEnabled ? 'disabled': '']">
                        <label :for="options.id"><span class="img_radio"><img :src="options.img_src"
                                                                              :class="options.class"/></span></label>
                      </div>

                      <div class="field" v-if="options.type == 'select'">
                        <div class="control" :class="options.id">
                          <div class="select is-info">
                            <select :id="options.id" :name="options.name"
                                    v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input">
                              <option v-for="item in options.values" :value="item.value"> {{ item.text}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="field" v-if="options.type == 'textarea'">
                        <textarea :class="options.class" :id="options.id"
                                  v-model.trim="widgetConfig[currentWidget][options.name]"
                                  v-show="options.display_input"
                                  :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                        <p class="notice_max_char" v-if="options.maxLength"> Max {{ options.maxLength}} Characters</p>
                      </div>
                      <div class="field " v-if="options.type == 'color'">
                        <verte v-if="!hideFontColor" :id="options.id" position="left" picker="square"
                               :showHistory="false" v-model.trim="widgetConfig[currentWidget][options.name]"
                               model="hex">
                        </verte>
                        <div v-show="hideFontColor" id="dummy_color_picker"/>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'download_link'">
                        <img class="download_img" src="/static/img/download-icon.png">
                        <a :class="options.class" @click.prevent="handle_function_call(options.clk)"
                           href="#">Download</a>
                      </div>
                      <div class="field star-rating-container" v-if="options.type === 'star-rating'">
                        <verte :id="options.id" position="left"
                               v-model="widgetConfig[currentWidget][options.name]" picker="square" :showHistory="false"
                               v-model.trim="widgetConfig[currentWidget][options.name]" model="hex"></verte>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        <div class="stars"><span class="fa fa-star" v-for="index in 5"
                                                 v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                        </div>
                        <label :for="options.id">{{ options.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dimension-wrapper" id="codeblock-container">
                  <p id="codeblock" class="codeblock" :disabled="showDummyReview" v-text="metricDisplayBadgeCodeBlock"></p>
                </div>
                <div class="dimension-wrapper dimension_html_box" style="min-height: 16px; margin-bottom:40px">
                  <button :data-track="widgetsProperties.title" @click="copyLink(metricDisplayBadgeCodeBlock)"
                          href="javascript:void(0)" :disabled="showDummyReview" :class="['is-pulled-right button']">
                    Copy Code
                  </button>
                </div>
              </div>
            </div>
            <div class="md4 verified_review_badge_container">
              <preview-widget :myprops="widgetConfig[currentWidget]" ref="verifiedBadge"></preview-widget>
            </div>
          </div>

          <div class="main-container-full" v-if="currentWidget == 'verticalFeed'">
            <p class="paragrph-style full-width-title">{{ widgetsProperties.short_description}} </p>
            <div class="fullwidth">
              <div class="vertical_feed_preview vertical_feed_preview_high">
                <div class="dummy-msg-warning-" v-if="dummyWarning">
                  <span>!</span><p>The widget displayed is <b>an example for demonstration purposes</b> only. You need a minimum of five positive reviews (4 & 5 stars) in the last 12 months to use this Widget.</p></div>
                  <preview-widget :myprops="widgetConfig[currentWidget]" ref="vertical_feed"></preview-widget>
              </div>
            </div>
            <div class="fullwidth">

              <div class="md6 vertical_feed_prop_section">
                <div class="left-side-container">
                  <div v-for="property in widgetsProperties.properties"
                       :class="['dimension-wrapper ', [property.prop_class]]">
                    <h4>{{ property.prop_title }}</h4>
                    <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                    <div :class="['prop_container', [prop.prop_class]]" v-for="prop in property.prop_option ">
                      <p v-if="prop.title" class="paragrph-style">{{ prop.title}}</p>
                      <div :class="options.class" v-for="options in prop.options">

                        <div class="field" v-if="options.type == 'radio' ">
                          <input :value="options.value" type="radio" :id="options.id" :name="options.name"
                                 v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                                 class="is-checkradio has-background-color is-info"
                                 @change="options.clk && handle_function_call(options.clk)" >
                          <label :for="options.id">{{ options.label }}</label>
                          <label class="sub_label" v-if="options.sub_label">{{ options.sub_label }}</label>
                        </div>
                        <div class="field" v-if="options.type == 'checkbox'">
                          <input :value="options.value" type="checkbox" :id="options.id" :name="options.name"
                                 v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                                 :disabled="!hideIndustryRanking"
                                 :class="['is-checkradio', 'has-background-color', 'is-info',!hideIndustryRanking ? 'disabled': '']">
                          <label :for="options.id">{{ options.label }}</label>
                        </div>

                        <div class="field" v-if="options.type == 'radio_img'">
                          <input type="radio" :value="options.value" :id="options.id" :name="options.name"
                                 :disabled="!isLogoEnabled" v-model="widgetConfig[currentWidget][options.name]"
                                 v-show="options.display_input"
                                 :class="['is-checkradio', 'has-background-color', 'is-info', !isLogoEnabled ? 'disabled': '']">
                          <label :for="options.id">
                            <span class="img_radio"><img :src="options.img_src" :class="options.class"/>
                            </span>
                          </label>
                        </div>

                        <div class="field" v-if="options.type == 'select'">
                          <div class="control" :class="options.id">
                            <div class="select is-info">
                              <select :id="options.id" :name="options.name"
                                      v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input">
                                <option v-for="(item, index) in options.values" :key="index" :value="item.value"> {{ item.text}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="field" v-if="options.type == 'textarea'">
                          <textarea :class="options.class" :id="options.id"
                                    v-model.trim="widgetConfig[currentWidget][options.name]"
                                    v-show="options.display_input"
                                    :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                          <p class="notice_max_char" v-if="options.maxLength"> Max {{ options.maxLength}} Characters</p>
                        </div>
                        <div class="field " v-if="options.type == 'color'">
                          <verte v-if="!hideFontColor" :id="options.id" position="left" picker="square"
                                 :showHistory="false" v-model.trim="widgetConfig[currentWidget][options.name]"
                                 model="hex">
                          </verte>
                          <div v-show="hideFontColor" id="dummy_color_picker"/>
                          <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        </div>
                        <div class="field " v-if="options.type == 'metrics_channel' && widgetConfig['verticalFeed']['widget_header'] == 'metrics'">
                          <channel-manage v-bind:hpEnable="false"  v-bind:googleChecked="widgetConfig[currentWidget][options.name]" @channel-manage-toggle="metricFilterToggle($event.checked, $event.channel)"/>
                        </div>
                        <div class="field " v-if="options.type == 'reviews_channel' && widgetConfig['verticalFeed']['widget_header'] == 'text'">
                          <channel-manage v-bind:hpEnable="false"  v-bind:googleChecked="widgetConfig[currentWidget][options.name]" @channel-manage-toggle="channelFilterToggle($event.checked, $event.channel)"/>
                        </div>


                        <div class="field" v-if="options.type == 'download_link'">
                          <img class="download_img" src="/static/img/download-icon.png">
                          <a :class="options.class" @click.prevent="handle_function_call(options.clk)"
                             href="#">Download</a>
                        </div>
                        <div class="field star-rating-container" v-if="options.type === 'star-rating'">
                          <verte :id="options.id" position="left"
                                 picker="square" :showHistory="false"
                                 v-model.trim="widgetConfig[currentWidget][options.name]" model="hex"></verte>
                          <label class="color_label_holder" :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                          <div class="stars">
                            <span class="fa fa-star" v-for="index in 5" :key="index"
                                  v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                          </div>
                          <label :for="options.id">{{ options.label }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cta_container">
                    <div class="dimension-wrapper width-80-codeblock" id="codeblock-container">
                      <p id="codeblock" class="codeblock" :disabled="dummyWarning" v-text="verticalFeedCodeBlock"></p>
                    </div>
                    <div class="dimension-wrapper dimension_html_box" style="min-height: 16px;">
                      <button  @click="copyLink(verticalFeedCodeBlock)"
                               href="javascript:void(0)" :disabled="dummyWarning" data-track="vertical feed" :class="['is-pulled-right button v-feed_copy_code']">
                        Copy Code
                      </button>
                    </div>
                  </div>

                </div>
              </div>

            </div>




          </div>

          <div class="main-container-full" v-if="currentWidget == 'reviewSlider'">
            <p class="paragrph-style full-width-title">{{ widgetsProperties.short_description}} </p>
            <div class="fullwidth">
              <div class="vertical_feed_preview vertical_feed_preview_high reviewSliderPreview">
                <div class="dummy-msg-warning-" v-if="dummyWarning">
                  <span>!</span><p>The widget displayed is <b>an example for demonstration purposes</b> only. You need a minimum of five positive reviews (4 & 5 stars) in the last 12 months to use this Widget.</p></div>
                <preview-widget :myprops="widgetConfig[currentWidget]" ref="vertical_feed"></preview-widget>
              </div>
            </div>
            <div class="fullwidth">

              <div class="md6 vertical_feed_prop_section">
                <div class="left-side-container">
                  <div v-for="property in widgetsProperties.properties"
                       :class="['dimension-wrapper ', [property.prop_class]]">
                    <h4>{{ property.prop_title }}</h4>
                    <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                    <div :class="['prop_container', [prop.prop_class]]" v-for="prop in property.prop_option ">
                      <p v-if="prop.title" class="paragrph-style">{{ prop.title}}</p>
                      <div :class="options.class" v-for="options in prop.options">

                        <div class="field" v-if="options.type == 'radio' ">
                          <input :value="options.value" type="radio" :id="options.id" :name="options.name"
                                 v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                                 class="is-checkradio has-background-color is-info"
                                 @change="options.clk && handle_function_call(options.clk)" >
                          <label :for="options.id">{{ options.label }}</label>
                          <label class="sub_label" v-if="options.sub_label">{{ options.sub_label }}</label>
                        </div>
                        <div class="field" v-if="options.type == 'checkbox'">
                          <input :value="options.value" type="checkbox" :id="options.id" :name="options.name"
                                 v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                                 :disabled="!hideIndustryRanking"
                                 :class="['is-checkradio', 'has-background-color', 'is-info',!hideIndustryRanking ? 'disabled': '']">
                          <label :for="options.id">{{ options.label }}</label>
                        </div>

                        <div class="field" v-if="options.type == 'radio_img'">
                          <input type="radio" :value="options.value" :id="options.id" :name="options.name"
                                 :disabled="!isLogoEnabled" v-model="widgetConfig[currentWidget][options.name]"
                                 v-show="options.display_input"
                                 :class="['is-checkradio', 'has-background-color', 'is-info', !isLogoEnabled ? 'disabled': '']">
                          <label :for="options.id">
                            <span class="img_radio"><img :src="options.img_src" :class="options.class"/>
                            </span>
                          </label>
                        </div>

                        <div class="field" v-if="options.type == 'select'">
                          <div class="control" :class="options.id">
                            <div class="select is-info">
                              <select :id="options.id" :name="options.name"
                                      v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input">
                                <option v-for="(item, index) in options.values" :key="index" :value="item.value"> {{ item.text}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="field" v-if="options.type == 'textarea'">
                          <textarea :class="options.class" :id="options.id"
                                    v-model.trim="widgetConfig[currentWidget][options.name]"
                                    v-show="options.display_input"
                                    :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                          <p class="notice_max_char" v-if="options.maxLength"> Max {{ options.maxLength}} Characters</p>
                        </div>
                        <div class="field " v-if="options.type == 'color'">
                          <verte v-if="!hideFontColor" :id="options.id" position="left" picker="square"
                                 :showHistory="false" v-model.trim="widgetConfig[currentWidget][options.name]"
                                 model="hex">
                          </verte>
                          <div v-show="hideFontColor" id="dummy_color_picker"/>
                          <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        </div>
                        <div class="field " v-if="options.type == 'metrics_channel' && widgetConfig['reviewSlider']['widget_header'] == 'metrics'">
                          <channel-manage v-bind:hpEnable="false"  v-bind:googleChecked="widgetConfig[currentWidget][options.name]" @channel-manage-toggle="metricFilterToggle($event.checked, $event.channel)"/>
                        </div>
                        <div class="field " v-if="options.type == 'reviews_channel' ">
                          <channel-manage v-bind:hpEnable="false"  v-bind:googleChecked="widgetConfig[currentWidget][options.name]" @channel-manage-toggle="channelFilterToggle($event.checked, $event.channel)"/>
                        </div>


                        <div class="field" v-if="options.type == 'download_link'">
                          <img class="download_img" src="/static/img/download-icon.png">
                          <a :class="options.class" @click.prevent="handle_function_call(options.clk)"
                             href="#">Download</a>
                        </div>
                        <div class="field star-rating-container" v-if="options.type === 'star-rating'">
                          <verte :id="options.id" position="left"
                                 picker="square" :showHistory="false"
                                 v-model.trim="widgetConfig[currentWidget][options.name]" model="hex"></verte>
                          <label class="color_label_holder" :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                          <div class="stars">
                            <span class="fa fa-star" v-for="index in 5" :key="index"
                                  v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                          </div>
                          <label :for="options.id">{{ options.label }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cta_container">
                    <div class="dimension-wrapper width-80-codeblock" id="codeblock-container">
                      <p id="codeblock" class="codeblock" :disabled="dummyWarning" v-text="reviewSliderCodeBlock"></p>
                    </div>
                    <div class="dimension-wrapper dimension_html_box" style="min-height: 16px;">
                      <button  @click="copyLink(reviewSliderCodeBlock)"
                               href="javascript:void(0)" :disabled="dummyWarning" data-track="vertical feed" :class="['is-pulled-right button v-feed_copy_code']">
                        Copy Code
                      </button>
                    </div>
                  </div>

                </div>
              </div>

            </div>




          </div>

          <div class="main-container-full" v-if="currentWidget == 'carousel'">
            <p class="paragrph-style full-width-title">{{ widgetsProperties.short_description}} </p>
            <div class="fullwidth">
              <div class="vertical_feed_preview">
                <div class="dummy-msg-warning-" v-if="dummyWarning">
                  <span>!</span><p>The widget displayed is <b>an example for demonstration purposes</b> only. You need a minimum of five positive reviews (4 & 5 stars) in the last 12 months to use this Widget.</p></div>
                <preview-widget :myprops="widgetConfig[currentWidget]" ref="vertical_feed"></preview-widget>
              </div>
            </div>
            <div class="fullwidth">
              <div class="md6 vertical_feed_prop_section">
                <div class="left-side-container">
                  <div v-for="property in widgetsProperties.properties"
                       :class="['dimension-wrapper ', [property.prop_class]]">
                    <h4>{{ property.prop_title }}</h4>
                    <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                    <div :class="['prop_container', [prop.prop_class]]" v-for="prop in property.prop_option ">
                      <p v-if="prop.title" class="paragrph-style">{{ prop.title}}</p>
                      <div :class="options.class" v-for="options in prop.options">

                        <div class="field" v-if="options.type == 'radio' ">
                          <input :value="options.value" type="radio" :id="options.id" :name="options.name"
                                 v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                                 class="is-checkradio has-background-color is-info"
                                 @change="options.clk && handle_function_call(options.clk)"
                          >
                          <label :for="options.id">{{ options.label }}</label>
                          <label class="sub_label" v-if="options.sub_label">{{ options.sub_label }}</label>
                        </div>
                        <div class="field" v-if="options.type == 'checkbox'">
                          <input :value="options.value" type="checkbox" :id="options.id" :name="options.name"
                                 v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                                 :disabled="!hideIndustryRanking"
                                 :class="['is-checkradio', 'has-background-color', 'is-info',!hideIndustryRanking ? 'disabled': '']">
                          <label :for="options.id">{{ options.label }}</label>
                        </div>

                        <div class="field" v-if="options.type == 'radio_img'">
                          <input type="radio" :value="options.value" :id="options.id" :name="options.name"
                                 :disabled="!isLogoEnabled" v-model="widgetConfig[currentWidget][options.name]"
                                 v-show="options.display_input"
                                 :class="['is-checkradio', 'has-background-color', 'is-info', !isLogoEnabled ? 'disabled': '']">
                          <label :for="options.id">
                            <span class="img_radio"><img :src="options.img_src" :class="options.class"/>
                            </span>
                          </label>
                        </div>

                        <div class="field" v-if="options.type == 'select'">
                          <div class="control" :class="options.id">
                            <div class="select is-info">
                              <select :id="options.id" :name="options.name"
                                      v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input">
                                <option v-for="(item, index) in options.values" :key="index" :value="item.value"> {{ item.text}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="field" v-if="options.type == 'textarea'">
                          <textarea :class="options.class" :id="options.id"
                                    v-model.trim="widgetConfig[currentWidget][options.name]"
                                    v-show="options.display_input"
                                    :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                          <p class="notice_max_char" v-if="options.maxLength"> Max {{ options.maxLength}} Characters</p>
                        </div>
                        <!-- HERE -->
                        <div class="field " v-if="options.type == 'metrics_channel' && widgetConfig['carousel']['widget_header'] == 'metrics'">
                          <channel-manage v-bind:hpEnable="false"  v-bind:googleChecked="widgetConfig[currentWidget][options.name]" @channel-manage-toggle="metricFilterToggle($event.checked, $event.channel)"/>
                        </div>
                        <div class="field " v-if="options.type == 'reviews_channel' && widgetConfig['carousel']['widget_header'] == 'text'">
                          <channel-manage v-bind:hpEnable="false"  v-bind:googleChecked="widgetConfig[currentWidget][options.name]" @channel-manage-toggle="channelFilterToggle($event.checked, $event.channel)"/>
                        </div>

                        <div class="field " v-if="options.type == 'color'">
                          <verte v-if="!hideFontColor" :id="options.id" position="left" picker="square"
                                 :showHistory="false" v-model.trim="widgetConfig[currentWidget][options.name]"
                                 model="hex">
                          </verte>
                          <div v-show="hideFontColor" id="dummy_color_picker"/>
                          <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        </div>
                        <div class="field" v-if="options.type == 'download_link'">
                          <img class="download_img" src="/static/img/download-icon.png">
                          <a :class="options.class" @click.prevent="handle_function_call(options.clk)"
                             href="#">Download</a>
                        </div>
                        <div class="field star-rating-container" v-if="options.type === 'star-rating'">
                          <verte :id="options.id" position="left"
                                 picker="square" :showHistory="false"
                                 v-model.trim="widgetConfig[currentWidget][options.name]" model="hex"></verte>
                          <label class="color_label_holder" :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                          <div class="stars">
                            <span class="fa fa-star" v-for="index in 5" :key="index"
                                  v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                          </div>
                          <label :for="options.id">{{ options.label }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cta_container">
                    <div class="dimension-wrapper width-80-codeblock" id="codeblock-container">
                      <p id="codeblock" class="codeblock" :disabled="dummyWarning" v-text="carouselCodeBlock"></p>
                    </div>
                    <div class="dimension-wrapper dimension_html_box" style="min-height: 16px;">
                      <button  @click="copyLink(carouselCodeBlock)"
                               href="javascript:void(0)" :disabled="dummyWarning" data-track="vertical feed" :class="['is-pulled-right button v-feed_copy_code']">
                        Copy Code
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="main-container" id="onSiteWriteReview" v-if="currentWidget == 'onSiteWriteReview'">
            <div class="md6">
              <div class="left-side-container">
                <p class="paragrph-style"> {{ widgetsProperties.short_description}}</p>
                <div v-for="property in widgetsProperties.properties"
                     :class="['dimension-wrapper ', [property.prop_class]]">
                  <h4 v-if="property.prop_title">{{ property.prop_title }}</h4>
                  <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                  <div :class="['prop_container', [prop.prop_class], disableFields ? 'disable_container': '']" v-for="prop in property.prop_option ">
                    <p v-if="prop.title" class="paragrph-style">{{ prop.title}}</p>
                    <div :class="options.class" v-for="options in prop.options">
                      <div class="field" v-if="options.type == 'radio'">
                        <input :value="options.value" :disabled="options.allowedDisable && disableFields" type="radio" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                      </div>
                      <div class="field" v-if="options.type == 'checkbox'">
                        <input :value="options.value" type="checkbox" :id="options.id" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               class="is-checkradio has-background-color is-info">
                        <label :for="options.id">{{ options.label }}</label>
                      </div>

                      <div class="field" v-if="options.type == 'text'">
                        <input type="text" :id="options.id" :disabled="disableFields" :name="options.name"
                               v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input"
                               :class="options.class">
                        <label :for="options.id">{{ options.label }}</label>
                      </div>

                      <div class="field disabled" v-if="options.type == 'select'">
                        <div class="control" :class="options.id">
                          <div class="select is-info">
                            <select :id="options.id" :disabled="disableFields" :name="options.name"
                                    v-model="widgetConfig[currentWidget][options.name]" v-show="options.display_input">
                              <option v-for="item in options.values" :value="item.value"> {{ item.text}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="field" v-if="options.type == 'textarea'">
                        <textarea :class="options.class" :id="options.id"
                                  v-model.trim="widgetConfig[currentWidget][options.name]"
                                  v-show="options.display_input"
                                  :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                        <p class="notice_max_char" v-if="options.maxLength"> Max {{ options.maxLength}} Characters</p>
                      </div>
                      <div class="field" v-if="options.type == 'color'">
                        <verte :id="options.id" position="left" v-if="!disableFields" picker="square" :showHistory="false"
                               v-model.trim="widgetConfig[currentWidget][options.name]" model="hex">
                        </verte>
                        <div v-show="disableFields" id="dummy_color_picker"/>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                      </div>
                      <div class="field star-rating-container" v-if="options.type === 'star-rating'">
                        <verte :id="options.id" position="left"
                               v-model="widgetConfig[currentWidget][options.name]" picker="square" :showHistory="false"
                               v-model.trim="widgetConfig[currentWidget][options.name]" model="hex"></verte>
                        <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        <div class="stars"><span class="fa fa-star" v-for="index in 5"
                                                 v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                        </div>
                        <label :for="options.id">{{ options.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dimension-wrapper" id="codeblock-container-onsite">
                  <p id="codeblock" class="codeblock" :disabled="showDummyReviewRatingTab" v-text="onsiteReviewCodeBlock"></p>
                </div>
                <div class="dimension-wrapper dimension_html_box" style="min-height: 16px; margin-bottom:40px">
                  <button :data-track="widgetsProperties.title" @click="copyLink(onsiteReviewCodeBlock)"
                          href="javascript:void(0)" :disabled="showDummyReviewRatingTab" :class="['is-pulled-right button']">
                    Copy Code
                  </button>
                </div>
              </div>
            </div>
            <div class="md4">
              <preview-widget :myprops="widgetConfig[currentWidget]"></preview-widget>
            </div>
          </div>

          <div v-if="currentWidget == 'dropDown'" class="main-container-full dropdown_widget">
            <p class="paragrph-style full-width-title">{{ widgetsProperties.short_description }} </p>
            <div class="fullwidth">
              <div class="vertical_feed_preview dropdown_preview">
                <preview-widget ref="vertical_feed" :myprops="widgetConfig[currentWidget]"></preview-widget>
              </div>
            </div>
            <div class="fullwidth">

              <div class="md6 vertical_feed_prop_section">
                <div class="left-side-container">

                  <div v-for="property in widgetsProperties.properties"
                       :class="['dimension-wrapper ', [property.prop_class]]">
                    <h4>{{ property.prop_title }}</h4>
                    <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                    <div v-for="prop in property.prop_option " :class="['prop_container', [prop.prop_class]]">
                      <p v-if="prop.title" class="paragrph-style">{{ prop.title }}</p>
                      <div v-for="options in prop.options" :class="options.class">

                        <div v-if="options.type == 'radio' " class="field">
                          <input v-show="options.display_input" :id="options.id" v-model="widgetConfig[currentWidget][options.name]" :name="options.name"
                                 :value="options.value" class="is-checkradio has-background-color is-info"
                                 type="radio">
                          <label :for="options.id">{{ options.label }}</label>
                          <label v-if="options.sub_label" class="sub_label">{{ options.sub_label }}</label>
                        </div>
                        <div v-if="options.type == 'checkbox'" class="field">
                          <input v-show="options.display_input" :id="options.id" v-model="widgetConfig[currentWidget][options.name]" :class="['is-checkradio', 'has-background-color', 'is-info',!hideIndustryRanking ? 'disabled': '']"
                                 :disabled="!hideIndustryRanking" :name="options.name"
                                 :value="options.value"
                                 type="checkbox">
                          <label :for="options.id">{{ options.label }}</label>
                        </div>

                        <div v-if="options.type == 'radio_img'" class="field">
                          <input v-show="options.display_input" :id="options.id" v-model="widgetConfig[currentWidget][options.name]" :class="['is-checkradio', 'has-background-color', 'is-info', !isLogoEnabled ? 'disabled': '']"
                                 :disabled="!isLogoEnabled" :name="options.name"
                                 :value="options.value"
                                 type="radio">
                          <label :for="options.id">
                            <span class="img_radio"><img :class="options.class" :src="options.img_src"/>
                            </span>
                          </label>
                        </div>

                        <div v-if="options.type == 'select'" class="field">
                          <div :class="options.id" class="control">
                            <div class="select is-info">
                              <select v-show="options.display_input" :id="options.id"
                                      v-model="widgetConfig[currentWidget][options.name]"
                                      :name="options.name">
                                <option v-for="(item, index) in options.values" :key="index" :value="item.value">
                                  {{ item.text }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div v-if="options.type == 'textarea'" class="field">
                          <textarea v-show="options.display_input" :id="options.id"
                                    v-model.trim="widgetConfig[currentWidget][options.name]"
                                    :class="options.class"
                                    :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                          <p v-if="options.maxLength" class="notice_max_char"> Max {{ options.maxLength }}
                            Characters</p>
                        </div>
                        <div v-if="options.type == 'color'" class="field ">
                          <verte v-if="!hideFontColor" :id="options.id" v-model.trim="widgetConfig[currentWidget][options.name]" :showHistory="false"
                                 model="hex" picker="square"
                                 position="left">
                          </verte>
                          <div v-show="hideFontColor" id="dummy_color_picker"/>
                          <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        </div>
                        <div v-if="options.type == 'download_link'" class="field">
                          <img class="download_img" src="/static/img/download-icon.png">
                          <a :class="options.class" href="#"
                             @click.prevent="handle_function_call(options.clk)">Download</a>
                        </div>
                        <div v-if="options.type === 'star-rating'" class="field star-rating-container">
                          <verte :id="options.id" v-model.trim="widgetConfig[currentWidget][options.name]"
                                 :showHistory="false" model="hex"
                                 picker="square" position="left"></verte>
                          <label :for="options.id"
                                 class="color_label_holder">{{ widgetConfig[currentWidget][options.name] }}</label>
                          <div class="stars">
                            <span v-for="index in 5" :key="index" class="fa fa-star"
                                  v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                          </div>
                          <label :for="options.id">{{ options.label }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cta_container">
                    <div id="codeblock-container" class="dimension-wrapper width-80-codeblock">
                      <p id="codeblock" :disabled="showDummySeoMsg" class="codeblock" v-text="dropDownCodeBlock"></p>
                    </div>
                    <div class="dimension-wrapper dimension_html_box" style="min-height: 16px;">
                      <button :class="['is-pulled-right button v-feed_copy_code']"
                              :disabled="showDummySeoMsg" data-track="seo page" href="javascript:void(0)"
                              @click="copyLink(dropDownCodeBlock)">
                        Copy Code
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="currentWidget == 'seoPage'" class="main-container-full">
            <p class="paragrph-style full-width-title">{{ widgetsProperties.short_description }} </p>
            <div class="fullwidth">
              <div class="vertical_feed_preview seopage_preview">
                <div v-if="showDummySeoMsg" class="dummy-msg-warning-">
                  <span>!</span>
                  <p>The widget displayed is <b>an example for demonstration purposes</b> only. You need a minimum of
                    five positive reviews (3,4 & 5 stars) in the last 12 months to use this Widget.</p></div>
                <preview-widget ref="vertical_feed" :myprops="widgetConfig[currentWidget]"></preview-widget>
              </div>
            </div>
            <div class="fullwidth">

              <div class="md6 vertical_feed_prop_section">
                <div class="left-side-container">

                  <div v-for="property in widgetsProperties.properties"
                       :class="['dimension-wrapper ', [property.prop_class]]">
                    <h4>{{ property.prop_title }}</h4>
                    <p v-if="property.prop_desc">{{ property.prop_desc }}</p>
                    <div v-for="prop in property.prop_option " :class="['prop_container', [prop.prop_class]]">
                      <p v-if="prop.title" class="paragrph-style">{{ prop.title }}</p>
                      <div v-for="options in prop.options" :class="options.class">

                        <div v-if="options.type == 'radio' " class="field">
                          <input v-show="options.display_input" :id="options.id" v-model="widgetConfig[currentWidget][options.name]" :name="options.name"
                                 :value="options.value" class="is-checkradio has-background-color is-info"
                                 type="radio">
                          <label :for="options.id">{{ options.label }}</label>
                          <label v-if="options.sub_label" class="sub_label">{{ options.sub_label }}</label>
                        </div>
                        <div v-if="options.type == 'checkbox'" class="field">
                          <input v-show="options.display_input" :id="options.id" v-model="widgetConfig[currentWidget][options.name]" :class="['is-checkradio', 'has-background-color', 'is-info',!hideIndustryRanking ? 'disabled': '']"
                                 :disabled="!hideIndustryRanking" :name="options.name"
                                 :value="options.value"
                                 type="checkbox">
                          <label :for="options.id">{{ options.label }}</label>
                        </div>

                        <div v-if="options.type == 'radio_img'" class="field">
                          <input v-show="options.display_input" :id="options.id" v-model="widgetConfig[currentWidget][options.name]" :class="['is-checkradio', 'has-background-color', 'is-info', !isLogoEnabled ? 'disabled': '']"
                                 :disabled="!isLogoEnabled" :name="options.name"
                                 :value="options.value"
                                 type="radio">
                          <label :for="options.id">
                            <span class="img_radio"><img :class="options.class" :src="options.img_src"/>
                            </span>
                          </label>
                        </div>

                        <div class="field " v-if="options.type == 'metrics_channel' && widgetConfig['seoPage']['widget_header'] == 'metrics'">
                          <channel-manage v-bind:hpEnable="false"  v-bind:googleChecked="widgetConfig[currentWidget][options.name]" @channel-manage-toggle="metricFilterToggle($event.checked, $event.channel)"/>
                        </div>
                        <div class="field " v-if="options.type == 'reviews_channel' && widgetConfig['seoPage']['widget_header'] == 'text'">
                          <channel-manage v-bind:hpEnable="false"  v-bind:googleChecked="widgetConfig[currentWidget][options.name]" @channel-manage-toggle="channelFilterToggle($event.checked, $event.channel)"/>
                        </div>

                        <div v-if="options.type == 'select'" class="field">
                          <div :class="options.id" class="control">
                            <div class="select is-info">
                              <select v-show="options.display_input" :id="options.id"
                                      v-model="widgetConfig[currentWidget][options.name]"
                                      :name="options.name">
                                <option v-for="(item, index) in options.values" :key="index" :value="item.value">
                                  {{ item.text }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div v-if="options.type == 'textarea'" class="field">
                          <textarea v-show="options.display_input" :id="options.id"
                                    v-model.trim="widgetConfig[currentWidget][options.name]"
                                    :class="options.class"
                                    :maxlength="options.maxLength ? options.maxLength : ''"></textarea>
                          <p v-if="options.maxLength" class="notice_max_char"> Max {{ options.maxLength }}
                            Characters</p>
                        </div>
                        <div v-if="options.type == 'color'" class="field ">
                          <verte v-if="!hideFontColor" :id="options.id" v-model.trim="widgetConfig[currentWidget][options.name]" :showHistory="false"
                                 model="hex" picker="square"
                                 position="left">
                          </verte>
                          <div v-show="hideFontColor" id="dummy_color_picker"/>
                          <label :for="options.id">{{ widgetConfig[currentWidget][options.name] }}</label>
                        </div>
                        <div v-if="options.type == 'download_link'" class="field">
                          <img class="download_img" src="/static/img/download-icon.png">
                          <a :class="options.class" href="#"
                             @click.prevent="handle_function_call(options.clk)">Download</a>
                        </div>
                        <div v-if="options.type === 'star-rating'" class="field star-rating-container">
                          <verte :id="options.id" v-model.trim="widgetConfig[currentWidget][options.name]"
                                 :showHistory="false" model="hex"
                                 picker="square" position="left"></verte>
                          <label :for="options.id"
                                 class="color_label_holder">{{ widgetConfig[currentWidget][options.name] }}</label>
                          <div class="stars">
                            <span v-for="index in 5" :key="index" class="fa fa-star"
                                  v-bind:style="{ color: index <= options.colored ? widgetConfig[currentWidget][options.name] : '#ccc' }"></span>
                          </div>
                          <label :for="options.id">{{ options.label }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cta_container">
                    <div id="codeblock-container" class="dimension-wrapper width-80-codeblock">
                      <p id="codeblock" :disabled="showDummySeoMsg" class="codeblock" v-text="seoPageCodeBlock"></p>
                    </div>
                    <div class="dimension-wrapper dimension_html_box" style="min-height: 16px;">
                      <button :class="['is-pulled-right button v-feed_copy_code']"
                              :disabled="showDummySeoMsg" data-track="seo page" href="javascript:void(0)"
                              @click="copyLink(seoPageCodeBlock)">
                        Copy Code
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef */
import qs from 'qs'
import moment from 'moment'
import axios from 'axios'
import download from 'downloadjs'
import domtoimage from 'dom-to-image'
import ReviewCarousel from '../../widgets/TopReviewsCarousel.vue'
import ReviewVertical from '../../widgets/TopReviewsVertical.vue'
import Misc from './../../mixins/misc.js'
import GMB from './../../mixins/gmb.js'
import ReviewsWidgetMixin from '@/mixins/reviews-widget.js'
import WidgetCollectionMixin from '@/mixins/widgets-collection.js'
import PreviewWidget from '../../components/PreviewWidget.vue'
import ChannelManage from '../../components/ChannelManage.vue'
import verte from 'verte'
import 'verte/dist/verte.css'

export default {
  metaInfo: {
    title: 'Business Portal | Hellopeter - Onsite Widgets Badges'
  },
  components: {
    ReviewCarousel,
    ReviewVertical,
    PreviewWidget,
    verte,
    ChannelManage
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Onsite Widgets Badges'
    })
  },
  updated () {
    let _watcher = {
      deep: true,
      handler (before, after) {
        this.isFormChanged = true
      }
    }
    let watchElement = 'widgetConfig.' + this.$router.currentRoute.params.type
    this.$watch(watchElement, _watcher)
  },
  name: 'widgetdetails',
  mixins: [Misc, ReviewsWidgetMixin, WidgetCollectionMixin, GMB],
  data () {
    return {
      isFormChanged: false,
      leavingPage: false,
      trustScore: 0,
      finalScore: 0,
      totalReviews: 0,
      one: 0,
      two: 0,
      three: 0,
      four: 0,
      five: 0,
      businessSlug: localStorage.getItem('org_slug'),
      org_name: localStorage.getItem('org_name'),
      total_reviews: 1,
      avg_rating: 1,
      trust_index_score: 1,
      industry_ranking: 1,
      color: '#ccc',
      widgetConfig: {
        reviewTab: {
          'widget_header_text': 'What our customers say:',
          'font_color': '#000',
          'tab_color': '#ccc',
          'review_button_color': '#2384b5',
          'review_button_font_color': '#fff2f2',
          'five_star_rating_color': '#00BF87',
          'average_star_rating_color': '#00BF87',
          'four_star_rating_color': '#30C8A7',
          'display_industry_ranking': true,
          'widget_header': true,
          'metrics': true,
          'tab_opacity': 50,
          'tab_position': 'left',
          'num_of_reviews': 10,
          'reviewers_name_as_anonymous': false,
          'isMobile': false,
          'showTagLine': true,
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4149917-review-tab-widget'
        },
        metricDisplayBadge: {
          'widget_background_color': 'original',
          'font_color': '#58595b',
          'logo_color': 'logo-transparent.svg',
          'average_star_rating_color': '#00BF87',
          'isMobile': false,
          'previewBackground': 'transparent',
          'is_logo_disable': true,
          'display_industry_rank': true,
          'previewIframeHeight': '144px',
          'previewIframeWidth': '519px',
          'showTagLine': false,
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4423886-metric-display-widget '
        },
        reviewBadge: {
          'widget_background_color': 'original',
          'font_color': '#58595b',
          'logo_color': 'logo-transparent.svg',
          'average_star_rating_color': '#00BF87',
          'isMobile': false,
          'previewBackground': 'transparent',
          'is_logo_disable': true,
          'previewIframeHeight': '144px',
          'previewIframeWidth': '519px',
          'showTagLine': false,
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4210430-verified-review-badge'
        },
        verifiedSiteBadge: {
          'widget_background_color': 'original',
          'font_color': '#58595b',
          'logo_color': 'logo-transparent.svg',
          'isMobile': false,
          'previewBackground': 'transparent',
          'is_logo_disable': true,
          'previewIframeHeight': '144px',
          'previewIframeWidth': '519px',
          'showTagLine': false,
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4210430-verified-review-badge'
        },
        ribbonBadge: {
          'widget_background_color': 'original',
          'font_color': '#58595b',
          'logo_color': 'logo-transparent.svg',
          'average_star_rating_color': '#00BF87',
          'isMobile': false,
          'previewBackground': 'transparent',
          'is_logo_disable': true,
          'previewIframeHeight': '144px',
          'previewIframeWidth': '519px',
          'showTagLine': false,
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4529352-ribbon-badge-widget'
        },
        verticalFeed: {
          'widget_background_color': 'original',
          'dimension': '320',
          'font_color': '#58595b',
          'logo_color': 'logo-transparent.svg',
          'five_star_rating_color': '#00BF87',
          'average_star_rating_color': '#00BF87',
          'four_star_rating_color': '#30C8A7',
          'widget_header': 'metrics',
          'display_industry_ranking': true,
          'isMobile': false,
          'previewBackground': '#2484b5',
          'is_logo_disable': true,
          'previewIframeHeight': '458px',
          'previewIframeWidth': '320px',
          'num_of_reviews': 10,
          'google_metrix': false,
          'google_reviews': false,
          'facebook_metrix': false,
          'facebook_reviews': false,
          'reviewers_name_as_anonymous': false,
          'showTagLine': false,
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4409132-vertical-feed'
        },
        reviewSlider: {
          'widget_background_color': 'original',
          'dimension': '320',
          'five_star_rating_color': '#00BF87',
          'average_star_rating_color': '#00BF87',
          'four_star_rating_color': '#30C8A7',
          'isMobile': false,
          'previewBackground': '#2484b5',
          'is_logo_disable': true,
          'previewIframeHeight': '720px',
          'previewIframeWidth': '519px',
          'num_of_reviews': 10,
          'google_reviews': false,
          'facebook_reviews': false,
          'reviewers_name_as_anonymous': false,
          'showTagLine': false,
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4409132-vertical-feed'
        },
        carousel: {
          'widget_background_color': 'original',
          'dimension': '320',
          'font_color': '#58595b',
          'logo_color': 'logo-transparent.svg',
          'five_star_rating_color': '#00BF87',
          'average_star_rating_color': '#00BF87',
          'four_star_rating_color': '#30C8A7',
          'widget_header': 'metrics',
          'display_industry_ranking': true,
          'isMobile': false,
          'previewBackground': '#2484b5',
          'is_logo_disable': true,
          'previewIframeHeight': '365px',
          'previewIframeWidth': '300px',
          'num_of_reviews': 10,
          'reviewers_name_as_anonymous': false,
          'google_metrix': false,
          'google_reviews': false,
          'facebook_metrix': false,
          'facebook_reviews': false,
          'showTagLine': false,
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4410339-carousel-widget'
        },
        seoPage: {
          'widget_header_text': 'What our customers say:',
          'widget_background_color': 'original',
          'dimension': '700',
          'font_color': '#58595b',
          'five_star_rating_color': '#00BF87',
          'average_star_rating_color': '#00BF87',
          'four_star_rating_color': '#30C8A7',
          'three_star_rating_color': '#30C8A7',
          'isMobile': false,
          'previewBackground': '#2484b5',
          'is_logo_disable': true,
          'previewIframeHeight': '450px',
          'previewIframeWidth': '700px',
          'num_of_reviews': 10,
          'reviewers_name_as_anonymous': false,
          'display_replies': false,
          'showTagLine': false,
          'widget_header': 'metrics',
          'google_metrix': false,
          'google_reviews': false,
          'facebook_metrix': false,
          'facebook_reviews': false,
          'aboutLink': '#'
        },
        onSiteWriteReview: {
          'font_color': '#000',
          'widget_type': 'button',
          'desktop_width': '130',
          'desktop_height': '35',
          'mobile_width': '130',
          'mobile_height': '35',
          'btn_text': 'WRITE A REVIEW',
          'btn_font_family': 'Open Sans',
          'btn_font_size': '14px',
          'tab_color': '#ccc',
          'review_button_color': '#2384b5',
          'review_button_font_color': '#fff2f2',
          'tab_opacity': 50,
          'previewTagLine': 'Click the button or text link to see how the form will be displayed.',
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4410643-on-site-write-a-review-widget'
        },
        dropDown: {
          'dimension': 320,
          'widget_header_text': 'What our customers say:',
          'review_button_color': '#2384b5',
          'review_button_font_color': '#FFFFFF',
          'five_star_rating_color': '#00BF87',
          'average_star_rating_color': '#00BF87',
          'four_star_rating_color': '#30C8A7',
          'display_industry_ranking': true,
          'widget_header': true,
          'previewIframeHeight': 370,
          'metrics': true,
          'display_write_review_btn': false,
          'num_of_reviews': 10,
          'reviewers_name_as_anonymous': false,
          'isMobile': false,
          'showTagLine': true,
          'previewTagLine': 'Click on the dropdown to see your review feed.',
          'aboutLink': 'https://intercom.help/hellopeter/en/articles/4149917-review-tab-widget'
        }
      },
      org_id: localStorage.getItem('org_id'),
      can_use_hp_metrics: false,
      consumerFrontendUrl: process.env.APP_URL,
      reviewStarData: [],
      download_business_stats_url: undefined,
      download_trust_index_url: undefined,
      download_trust_index_blue_url: undefined,
      download_start_rating_url: undefined,
      widgetLibraryUrl: 'https://intercom.help/hellopeter/en/articles/4149917-review-tab-widget',
      reviewCarouselUrl: process.env.APP_URL + '/widgets/review-carousel/' + localStorage.getItem('org_slug'),
      starRatingUrl: process.env.APP_URL + '/widgets/star-rating/' + localStorage.getItem('org_slug'),
      reviewFeedUrl: process.env.APP_URL + '/widgets/review-feed/' + localStorage.getItem('org_slug'),
      subscriptionUpgradeLink: process.env.APP_URL + '/renew-or-upgrade-subscription',
      currentWidget: this.$route.params.type,
      isActive: false,
      previewWidth: 'width-80',
      previewWidthPercent: 'width-80-percent',
      slug: localStorage.getItem('org_slug'),
      showDummyReview: false,
      showDummyReviewRatingTab: false,
      showDummySeoMsg: false,
      dummyWarning: false,
      isLoading: true,
      hideTrustIndex: false,
      slidesPerPage: 3,
      renderTrustIndex: true,
      renderReviews: true,
      renderRating: true,
      renderIndustrRanking: true,
      showDummyReviewMsg: false
    }
  },
  created () {
    this.getReviewFeed().then((data) => {
      this.showDummyReview = data.showReviewBox
      this.isLoading = false
    })
    this.getBusinessTrustIndex()
    this.getWidget()
    this.getBusinessStarRating()
    this.getBusinessReviews()
    if (this.currentWidget === 'seoPage') {
      this.getBusinessReviewsWithReplies()
    }
    if (this.currentWidget === 'verticalFeed') {
      localStorage.setItem('widget_redirect_url', '/onsite-widgets/details/verticalFeed')
    }
    window.events.$on('navigateTowardsRoute', this.handleNavigation)
  },
  /**
   * Event before navigating to desired route
   * @param {object} to Route where user want to navigate
   * @param {object} from Route where is coming from navigation
   * @param {function} next Navigating towards the intended route if true
   * @return {void}
   */
  beforeRouteLeave (to, from, next) {
    // If user changed the form and is Enterprise/Pro user
    if (this.isFormChanged) {
      this.modal_props = {
        title: 'Are you sure?',
        body: 'You have unsaved changes on this page. If you navigate away, your changes will be lost. ',
        btn_action_title: 'STAY ON THIS PAGE',
        secondary_btn_title: 'LEAVE PAGE',
        to_path: to.path,
        show_btns: true,
        task: 'deleteInvite'
      }
      // Fire off confirmation modal
      modal(this.modal_props)
    } else {
      next()
    }
  },
  computed: {
    /**
     * Returns whether
     * @returns {boolean}
     */
    hideFontColor () {
      let currentWidgetType = this.$router.currentRoute.params.type
      if (this['widgetConfig'][currentWidgetType]['widget_background_color'] === 'original') {
        this['widgetConfig'][currentWidgetType]['font_color'] = '#58595b'
        this['widgetConfig'][currentWidgetType]['logo_color'] = 'logo-transparent.svg'

        return true
      } else {
        return false
      }
    },

    /**
     * Returns whether
     * @returns {boolean}
     */
    disableFields () {
      return this.widgetConfig.onSiteWriteReview.widget_type === 'link'
    },

    /**
     * Returns whether
     * @returns {boolean}
     */
    hideIndustryRanking () {
      let currentWidgetType = this.$router.currentRoute.params.type
      return this['widgetConfig'][currentWidgetType]['widget_header'] === 'metrics'
    },

    /**
     * Returns about this feature link
     * @returns {string}
     */
    aboutFeatureLink () {
      let currentWidgetType = this.$router.currentRoute.params.type
      if (this['widgetConfig'][currentWidgetType] === null || this['widgetConfig'][currentWidgetType] === undefined) {
        return
      }

      return this['widgetConfig'][currentWidgetType]['aboutLink'] ? this['widgetConfig'][currentWidgetType]['aboutLink'] : this.widgetLibraryUrl
    },
    /**
     *  Return verticalFeed widget script
     *  @returns  {string}
     */
    carouselCodeBlock () {
      let version = this.makeid(10)
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-code",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search', '` + this.businessSlug + `'),
                      script.setAttribute('data-params', '` + JSON.stringify(this.widgetConfig.carousel) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/carousel.js?v=` + version + `";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script type="text/javascript">` + code + `<${'/'}script><style>#hp-widget-vertical-feed-widget{display: none}</style><div id="hp-widget-vertical_feed"></div>`
    },
    /**
     *  Return verticalFeed widget script
     *  @returns  {string}
     */
    verticalFeedCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-code",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search', '` + this.businessSlug + `'),
                      script.setAttribute('data-params', '` + JSON.stringify(this.widgetConfig.verticalFeed) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/verticalFeed.js?v=2.2";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><style>#hp-widget-vertical-feed-widget{display: none}</style><div id="hp-widget-vertical_feed"></div>`
    },

    /**
     *  Return verticalFeed widget script
     *  @returns  {string}
     */
    reviewSliderCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-reviewslider-code",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search', '` + this.businessSlug + `'),
                      script.setAttribute('data-params', '` + JSON.stringify(this.widgetConfig.reviewSlider) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/reviewSlider.js?v=2.2";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><style>#hp-widget-review-slider{display: none}</style><div id="hp-widget-review-slider"></div>`
    },
    /**
     *  Return reviewBadge widget script
     *  @returns  {string}
     */
    reviewBadgeCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-code_vb",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search_vb', '` + this.businessSlug + `'),
                      script.setAttribute('data-params_vb', '` + JSON.stringify(this.widgetConfig.reviewBadge) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/verifiedBadge.js?v=2.2";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><a id='hp-widget-hp_profile_link' href='#'><div id="hp-widget-verified_review_badge"></div></a>`
    },

    /**
     *  Return reviewBadge widget script
     *  @returns  {string}
     */
    verifiedSiteBadgeCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-code-vsb",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search-vsb', '` + this.businessSlug + `'),
                      script.setAttribute('data-params-vsb', '` + JSON.stringify(this.widgetConfig.verifiedSiteBadge) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/verifiedSiteBadge.js?v=2.2";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><style> #hp-widget-verified_site_badge {display: none}</style><a id='hp-widget-hp_profile_link' href='#'><div id="hp-widget-verified_site_badge"></div></a>`
    },
    /**
     *  Return reviewBadge widget script
     *  @returns  {string}
     */
    ribbonBadgeCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="code-rb",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search-rb', '` + this.businessSlug + `'),
                      script.setAttribute('data-params-rb', '` + JSON.stringify(this.widgetConfig.ribbonBadge) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/ribbonBadge.js?v=2.1";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><a id='hp_profile_link' href='#'><style #hp-widget-verified_ribbon_badge { display:none}></style><div id="hp-widget-verified_ribbon_badge"></div></a>`
    },

    /**
     *  Return reviewBadge widget script
     *  @returns  {string}
     */
    metricDisplayBadgeCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="codemd",
                      script.setAttribute('data-apimd', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrlmd', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-searchmd', '` + this.businessSlug + `'),
                      script.setAttribute('data-paramsmd', '` + JSON.stringify(this.widgetConfig.metricDisplayBadge) + `'),
                      script.setAttribute('data-appFrontmd', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/metricDisplayBadge.js?v=2.2";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><a id='hp_profile_link' href='#'><style #hp-widget-metrics-display-badge { display:none}></style><div id="hp-widget-metrics-display-badge"></div></a>`
    },
    /**
     *  Return carousel widget iframe block
     *  @returns  {string}
     */
    reviewTabCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-code",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search', '` + this.businessSlug + `'),
                      script.setAttribute('data-params', '` + JSON.stringify(this.widgetConfig.reviewTab) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/ratingTab.js?v=2.2";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><style>#hp-widget-hp-ctn-howItWorks{display:none;}</style><div id="hp-widget-vertical_feed" class="hp-widget-container hp-widget-vertical-feed-widget"><div id="hp-widget-hp-modal"></div><div id="hp-widget-hp-ctn-howItWorks" data-toggle="modal">
        <p class="vertical-text"><span class="fa fa-star" style="color:#fff;"></span>Reviews</p>
      </div></div>`
    },
    /**
     *  Return carousel widget iframe block
     *  @returns  {string}
     */
    dropDownCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-code",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search', '` + this.businessSlug + `'),
                      script.setAttribute('data-params', '` + JSON.stringify(this.widgetConfig.dropDown) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/dropDown.js?v=2.2";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><style>#hp-widget-hp-ctn-howItWorks{display:none;} hp-widget-drop-down { display:none} #hp-widget-iframe-loader {display: none;}</style>
                <div class="hp-widget-modal" id="hp-widget-hp-modal" style="display: none"></div>
<div id="hp-widget-drop-down" class="hp-widget-container hp-widget-drop-down">
  <div id="hp-widget-rating-metrix" onclick="toggleReviews()"></div>
  <div id="hp-widget-dropdown-header"></div>
      </div>`
    },
    /**
     *  Return carousel widget iframe block
     *  @returns  {string}
     */
    onsiteReviewCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-code",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search', '` + this.businessSlug + `'),
                      script.setAttribute('data-params', '` + JSON.stringify(this.widgetConfig.onSiteWriteReview) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/onsiteReview.js?v=2.2";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><style>#hp-widget-hp-ctn-howItWorks{display:none;}</style><div id="hp-widget-vertical_feed" class="hp-widget-container hp-widget-vertical-feed-widget"><div id="hp-widget-hp-modal"></div><div id="hp-widget-hp-ctn-howItWorks"  data-toggle="modal">
        <p class="vertical-text">WRITE A REVIEW</p>
      </div></div>`
    },
    /**
     *  Return carousel widget iframe block
     *  @returns  {string}
     */
    reviewCarouselCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-code",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-search', '` + this.businessSlug + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/reviewCarousel.js";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                      var link = document.createElement( "link" );
                      link.href = "` + process.env.APP_URL + `/static/css/reviewCarousel.css";
                      link.type = "text/css";
                      link.rel = "stylesheet";
                      link.media = "screen,print";
                      var linkTag=document.getElementsByTagName("script")[0];
                      linkTag.parentNode.insertBefore(link,linkTag)
                    })()`
      return `<script type="text/javascript">` + code + `<${'/'}script><div id="hp-widget"></div>`
    },
    /**
     *  Return review feed widget iframe block
     *  @returns  {string}
     */
    reviewFeedCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="hp-widget-code",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.setAttribute('data-search', '` + this.businessSlug + `'),
                      script.src="` + process.env.APP_URL + `/static/js/reviewFeed.js";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                      var link = document.createElement( "link" );
                      link.href = "` + process.env.APP_URL + `/static/css/reviewFeed.css";
                      link.type = "text/css";
                      link.rel = "stylesheet";
                      link.media = "screen,print";
                      var linkTag=document.getElementsByTagName("script")[0];
                      linkTag.parentNode.insertBefore(link,linkTag)
                    })()`

      return `<script type="text/javascript">` + code + `<${'/'}script><div id="hp-widget"></div>`
    },
    /**
     * Return current subscription name
     * @returns {string}
     */

    /**
     *  Return verticalFeed widget script
     *  @returns  {string}
     */
    seoPageCodeBlock () {
      let code = `(function () { var script=document.createElement("script");
                      script.type="text/javascript",
                      script.async=!0,
                      script.id="code",
                      script.setAttribute('data-api', '` + process.env.API_URL + `'),
                      script.setAttribute('data-appUrl', '` + process.env.APP_URL + `'),
                      script.setAttribute('data-search', '` + this.businessSlug + `'),
                      script.setAttribute('data-params', '` + JSON.stringify(this.widgetConfig.seoPage) + `'),
                      script.setAttribute('data-appFront', '` + process.env.HP_APP_URL + `'),
                      script.src="` + process.env.APP_URL + `/static/js/seoPage.js?v=2.1.2";
                      var scriptTag=document.getElementsByTagName("script")[0];
                      scriptTag.parentNode.insertBefore(script,scriptTag)
                    })()`
      return `<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"><${'/'}script><script type="text/javascript">` + code + `<${'/'}script><div class="hp-widget-modal" style="display: none" id="hp-modal"></div>
  <div style="display: none" id='hp_seo_page'></div><img id="iframe-loader" src="${process.env.APP_URL}/static/img/ajax-loader.gif" />`
    },
    getCurrentSubscriptionName () {
      let subsDetails = JSON.parse(localStorage.getItem('billingDetails'))
      return subsDetails.subscription.name
    },
    /**
     * Check current subscription is free or not
     * @returns {boolean}
     */
    isFreeSubscription () {
      return this.getCurrentSubscriptionName === 'Free'
    },
    /**
     * returns whether widget background color is transparent
     * @returns {boolean}
     */
    isLogoEnabled () {
      let currentWidgetType = this.$router.currentRoute.params.type
      return this['widgetConfig'][currentWidgetType]['widget_background_color'] === 'transparent'
    }

  },
  watch: {
    'widgetConfig.verticalFeed.dimension': function (newVal, oldVal) {
      this.widgetConfig.verticalFeed.dimension = newVal
    }
  },
  methods: {
    handleNavigation (routeTowards) {
      this.leavingPage = true
      if (this.isFormChanged) {
        this.isFormChanged = false
        this.$router.push(routeTowards)
      }
    },

    /**
     * to call function dynamic
     * @param {string} functionName function name
     * @returns {void}
     */
    handle_function_call (functionName) {
      this[functionName]()
    },

    chooseGoogleReviews () {
      let currentWidgetType = this.$router.currentRoute.params.type
      if (currentWidgetType === 'reviewSlider') {
        this['widgetConfig'][currentWidgetType]['google_reviews'] = true
        this['widgetConfig'][currentWidgetType]['facebook_reviews'] = true
      } else {
        if (this['widgetConfig'][currentWidgetType]['widget_header'] === 'text') {
          this['widgetConfig'][currentWidgetType]['google_reviews'] = false
          this['widgetConfig'][currentWidgetType]['facebook_reviews'] = false
        } else {
          if (this['widgetConfig'][currentWidgetType]['google_metrix']) {
            this['widgetConfig'][currentWidgetType]['google_reviews'] = true
          } else {
            this['widgetConfig'][currentWidgetType]['google_reviews'] = false
          }
          if (this['widgetConfig'][currentWidgetType]['facebook_metrix']) {
            this['widgetConfig'][currentWidgetType]['facebook_reviews'] = true
          } else {
            this['widgetConfig'][currentWidgetType]['facebook_reviews'] = false
          }
        }
      }
    },
    makeid (length) {
      var result = ''
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      var charactersLength = characters.length
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },

    /**
     * Toggle between Desktop and mobile preview
     * @param {string} type device type
     * @returns {void}
     */
    responsiveCarousel (type) {
      this.isActive = !this.isActive
      this.previewWidthPercent = type === 'desktop' ? 'width-80-percent' : 'width-mob-306'
      this.slidesPerPage = type === 'desktop' ? 3 : 1
    },
    /**
     * Return download the current widget as image
     * @returns {void}
     */
    downloadPng () {
      let node = this.$refs.star
      domtoimage.toPng(node, {style: {'margin': '0px'}})
        .then(function (dataUrl) {
          download(dataUrl, 'image.png')
        })
        .catch(function (error) {
          console.error('oops, something went wrong!', error)
        })
    },
    /**
     * function to get business Trust Index
     * @returns {void}
     */
    getBusinessTrustIndex () { // temporary
      axios.get(`/${this.businessSlug}/reports/trust-index`)
        .then(({data}) => {
          this.trustScore = data.trustIndex
          if (data.reviewCountTotal < 10) {
            this.showDummyReviewMsg = true
            this.trustScore = 9.2
            this.renderTrustIndex = false
          }

          const apiPath = process.env.API_URL
          this.download_trust_index_url = `${apiPath}/widgets/${this.businessSlug}/download-metrics/trust-index`
          this.download_trust_index_blue_url = `${apiPath}/widgets/${this.businessSlug}/download-metrics/trust-index-blue`
        })
    },

    /**
     * function to get business stats to display dummy message on 5 reviews
     * @returns {void}
     */
    getBusinessReviews () {
      const apiPath = process.env.API_URL
      axios.get(`${apiPath}/widgets/${this.businessSlug}/review-feed`)
        .then(({data}) => {
          if (data.length < 5) {
            this.dummyWarning = true
            this.showDummyReviewRatingTab = true
          }
        })
    },
    /**
     * function to get business stats to display dummy message on 5 reviews
     * @returns {void}
     */
    getBusinessReviewsWithReplies () {
      const apiPath = process.env.API_URL
      let method = ''
      if (this.widgetConfig.seoPage.google_reviews) {
        method = 'review-feed-google-reply'
      } else {
        method = 'review-feed-reply'
      }
      axios.get(`${apiPath}/widgets/${this.businessSlug}/` + method)
        .then(({data}) => {
          console.log(data)
          if (data.reviews.length < 5) {
            this.showDummySeoMsg = true
          }
        })
    },
    /**
     * function to get business star rating
     * @returns {void}
     */
    getBusinessStarRating () { // temporary
      let endDate = moment()
      let startDate = moment()
      endDate.subtract(1, 'month')
      endDate.endOf('month')
      startDate.subtract(12, 'months')
      startDate.startOf('month')
      endDate = moment(endDate).format('YYYY-MM-DD')
      startDate = moment(startDate).format('YYYY-MM-DD')
      const queryString = qs.stringify({
        end_date: startDate,
        start_date: moment().format('YYYY-MM-DD')
      })
      axios.get(`/${this.businessSlug}/reports/star-rating?${queryString}`)
        .then(({data}) => {
          let newTotal = 0
          data.rows.forEach((row) => {
            switch (row[0]) {
              case '1 Star':
                this.one = row[1]
                break
              case '2 Stars':
                this.two = row[1]
                break
              case '3 Stars':
                this.three = row[1]
                break
              case '4 Stars':
                this.four = row[1]
                break
              case '5 Stars':
                this.five = row[1]
                break
              default:
                break
            }
            newTotal += row[1]
          })
          this.finalScore = 0.0
          this.totalReviews = newTotal
          if (newTotal > 0) {
            let one = this.one
            let two = this.two * 2
            let three = this.three * 3
            let four = this.four * 4
            let five = this.five * 5
            this.finalScore = parseFloat(((one + two + three + four + five) / newTotal).toFixed(1))
          }
          const apiPath = process.env.API_URL
          this.download_start_rating_url = `${apiPath}/widgets/${this.businessSlug}/download-metrics/star-rating`
        })
    },
    /**
     * function to copy code snippet to clip board
     * @returns {void}
     * @param {string} codeSnippet code snippet needs to copy
     */
    copyLink (codeSnippet) {
      this.$copyText(codeSnippet)
        .then(() => {
          this.isFormChanged = false
          this.displaySuccessMsg('Successfully copied this widget code snippet to your clipboard', 'Successfully copied widget code snippet to your clipboard')
        })
    },
    channelFilterToggle (isChecked, channel = '') {
      let currentWidgetType = this.$router.currentRoute.params.type
      if (channel === 'GOOGLE') {
        this['widgetConfig'][currentWidgetType]['google_reviews'] = isChecked
      }
      if (channel === 'FACEBOOK') {
        this['widgetConfig'][currentWidgetType]['facebook_reviews'] = isChecked
      }
    },
    metricFilterToggle (isChecked, channel = '') {
      let currentWidgetType = this.$router.currentRoute.params.type
      if (channel === 'GOOGLE') {
        this['widgetConfig'][currentWidgetType]['google_metrix'] = isChecked
        this['widgetConfig'][currentWidgetType]['google_reviews'] = isChecked
      }
      if (channel === 'FACEBOOK') {
        this['widgetConfig'][currentWidgetType]['facebook_metrix'] = isChecked
        this['widgetConfig'][currentWidgetType]['facebook_reviews'] = isChecked
      }
    },
    /**
     * @returns {void}
     * @param {string} widgetType widget
     */
    showDetails (widgetType) {
      $this.router.push({name: 'details', 'type': widgetType})
    }
  }
}
</script>

<style scoped>


.reviewSliderPreview .preview-com.vertical-30.width-80 {
  height: 600px !important;
  min-height: 600px !important;
  border: 2px solid;
  background: #ccc;
}
.reviewSliderPreview {
  height: 700px;
}

.reviewSliderPreview .preview-com {
  min-height: 700px;
}
/**** on-site review */
.widget_type .prop_container.disable_container {
  opacity: 1 !important;
}

.disable_container {
  opacity: .5;
}
#onSiteWriteReview .prop_container {
  margin: 0 !important;
}
.prop_container.font-size-container {
  display: inline-block;
  width: 111px;
  min-width: 111px;
}
#onSiteWriteReview input[type="text"]:disabled, #onSiteWriteReview select:disabled {
  background:transparent;
  border: 1px solid rgba(172,173,174, 0.5);
}
.desktop_width_input::after {
  content:'x';
  position: absolute;
  left: 57px;
  top: 4px;
}
select#btn_font_control {
  border-color: #c9c9ca;
  font-size: 12px;
  border-radius: 0px;
  padding: 3px 40px 1px 12px;
  min-height: 35px;
  color: #58595b;
  width: 226px;
}

.btn_font_control .select::after {
  border: 1px solid #58585b;
  border-right: 0px;
  border-top: 0px;
}
input#btn_txt {
  padding: 12px 9px;
  width: 226px;
  font-size: 12px;
  line-height: 17px;
  text-transform: uppercase;
  height: 35px;
  border: 1px solid #c9c9ca;
}
.review_button p{
  margin-bottom: 10px;
}
.btn_txt_container {
  padding-top: 72px;
  padding-bottom: 20px;
}
.btn_font {
  width: 276px;
  display: inline-block;
}

.prop_container.font-color-container {
  display: inline-block;
  /* margin-top: 19px; */
  position: relative;
  top: 12px;
  left: 32px;
}
.font_color .field {
  display: flex;
  align-items: center;
}
.font_color .field label {
  margin-left: 10px;
}
.num_of_reviews #num_of_reviews {
  width: 92px !important;
}
#onSiteWriteReview .font-color {
  float: right !important;
  width: 39% !important;
}
.dimension_txt label {
  position: absolute;
  top: 8px;
  left: 50px
}
.dimension-wrapper.widget_type .prop_container {
  width: 50%;
  margin: 0px !important;
  padding-bottom: 0px;
  /* border: 1px solid; */
}
.dimension-wrapper.widget_type {
  display: inline-flex;
  width: 50%;
  margin: 10px 0 0 0 !important;
}
@media screen and (min-width: 768px), print {
  .modal-content, .modal-card {
    margin: 0 auto;
    height: 635px;
    width: 600px;
    overscroll-behavior: contain;
    overflow-y: hidden;
  }
}

.widget_dimensions_txt .prop_container {
  width: 33% !important;
  display: inline-block;
}
.dimension_txt {
  display: inline-flex;
  width: 45px;
  height: 35px;
  margin: 0 36px 0 0;
  color: #58595b;
  text-align: center;
  position: relative;
}
#codeblock-container-onsite {
  clear: both;
}
.dimension-wrapper.clear {
  clear: both;
  /* margin-top: 100px;     */
}
/** vertical feed css */

.dummy-msg-warning- {
  height: 40px;
  width: 100%;
  border: 1px solid #2fabe1;
  color: #2fabe1;
  background: #f2fbfd;
  display: flex;
  margin-bottom: 25px;
  flex-direction: row;
  align-items: center;
}
.vertical_feed_preview {
  width: 100%;
}

.vertical_feed_prop_section .left-side-container  {
  width: 100% !important;
  border: 0px;

}
.vertical_feed_prop_section .widget_header_1 {
  display: inline-block;
  width: 90px;
}
.vertical_feed_prop_section .field {
  display: inline;
  width: 50px;
}
.average_star_rating_color {
  margin-left: 15px !important;
}
.vertical_feed_prop_section .stars {
  display: flex;
}
.vertical_feed_prop_section .display_industry_rank {
  display: block;
  width: 100%;
  margin-top: 10px;
}
.vertical_feed_preview .main-container-full .right-side-container {
  height: 400px !important;

}
/** vertical feed end */

/** verified badge css start  */



#dummy_color_picker {
  height: 30px;
  width: 30px;
  border: 15px solid #58595b;
  border-radius: 100%;
  background-color: #58595b;
  opacity: .5;
}

.sub_label {
  font-size: 12px;
  color: #58595b;
  opacity: .5;
}

.font_border_color .field {
  display: flex;
  align-items: center;
}

.font_border_color label, .field.star-rating-container label {
  margin-left: 7px !important;
}

img.transparent_background {
  background: #fff;
  padding: 2px 0px;
  width: 83px;
}

img.grey_background {
  background: #58595b;
  width: 83px;
}

img.blue_background {
  background: #30aae1;
  width: 83px;
}

.is-checkradio.disabled, .is-checkradio.disabled + label {
  opacity: .5;
}

.widget_background_color {
  display: inline-block;
  width: 16%;
}

.badge_widget_background_color {
  display: inline-block;
  width: 21%;
}

.img_radio img {
  position: absolute;
}

.img_radio {
  height: 25px;
  width: 83px;
  padding-left: 11px;
  margin-top: 8px !important;
}

.logo_color {
  display: inline-block;
  position: relative;
  width: 21%;
}

.v_feed_logo_color_container .logo_color {
  width: 10%;
}

.v_feed_logo_color_container .logo_color img{
  width: 83px;
  margin: 0px;
}

/** verified badge css end  */
.heading-top-info {
  font-weight: bold;
  margin-bottom: 10px;
  padding-bottom: 5px;
  font-size: 12px;
  line-height: 24px;
  color: #58595b;
}

#codeblock {
  word-wrap: break-word;
  border: 1px solid #dbdbdb;
  padding: 5px 10px;
  word-break: break-all;
  /* float: left; */
  width: 98%;
}
.v-feed_copy_code {

}

.v-feed_copy_code {
  margin-right: 0px !important;

}

.is-pulled-right {
  margin-right: 20px;
  margin-top: -25px;
}

.cta_container .is-pulled-right { margin-top: 0px !important;}

.width-80-codeblock {
  width: 86% !important;
  max-width: calc(100% - 210px);
}

.dimension-wrapper.widget_header h4 + p + div + div {
  float: left;
  width: 100%;
  clear: both;
}
.w_dimension { vertical-align: top;}

.dimension-wrapper.widget_header h4 + p + div .widget_header_1 {
  float: left;
  padding: 2px 45px 2px 0px;
}

.dimension-wrapper.widget_header h4 + p + div {
  width: 49%;
}

.widget_header {
  float: left;
  clear: both;
  width: 100%;
}

.dimension-wrapper.review_tab {
  float: left;
  width: 100%;
  clear: both;
}

.tab_color .field, .font-color .field, .prop_container.font-color {
  display: flex;
  align-items: center;
}

.prop_container.tab_color {
  display: inline-block;
  width: 21%;
  float: left;
}

.prop_container.tab_opacity {
  float: left;
  width: 50%;
  margin-left: 15px;
}

.prop_container.tab_opacity .is-checkradio {
  display: inline-block;
}

.prop_container.tab_opacity .is-checkradio .field {
  width: 70px;
  margin-top: 5px;
}

.prop_container.font-color {
  display: inline-block;
  float: left;
  width: 17%;
}

.prop_container {
  margin: 22px 0 5px 0
}

.review_button_colors .field {
  display: flex;
  align-items: center;
}

.tab_color .field label, .font-color .field label, .review_button_colors .field label {
  margin-left: 10px;
}
.full-width-title {
  /* text-align: center; */
  /* padding-top: 20px; */
  padding-bottom: 20px !important;
  margin-bottom: 20px;
}
.dummy-msg-warning- {
  padding: 0px 0px;
}
.dummy-msg-warning- span {
  border-right: 1px solid;
  height: 100%;
  display: inline-grid;
  margin-right: 20px;
  padding: 8px 20px;
  float: left;
}
.dummy-msg-warning- p {
  font-size: 12px;
}
p.paragrph-style {
  padding-bottom: 5px !important;
}

.prop_container.review_button_colors {
  display: inline-block;
  width: 21%;
}

.prop_container.name_anonymous {
  display: inline-block;
  width: 49%;
}

.prop_container.num_of_reviews {
  width: 19%;
  margin-top: 14px;
  display: inline-block;
  min-width: 265px;
}

.name_anonymous .is-checkradio, .display_replies .is-checkradio {
  display: inline-block;
}

.name_anonymous .is-checkradio .field, .display_replies .is-checkradio .field {
  width: 66px;
  display: inline-block;
}

.field.star-rating-container .stars {
  margin-left: 15px
}

.field.star-rating-container label {
  margin-left: 15px !important;
}

.prop_container .tab_position {
  display: inline-block;
  width: 22%;
}

.widget_dimensions .prop_container {
  width: 21%;
  display: inline-block;
}

.field label {
  font-size: 12px
}

.verte__guide {
  width: 30px !important;
  height: 30px !important;
}

.verte {
  width: 30px !important;
  height: 30px !important;
  display: inline-block;
}

.dimension-wrapper.widget_header h4 + p + div .widget_header_1 {
  float: left;
  padding: 2px 45px 2px 0px;
}

.dimension-wrapper.widget_header h4 + p + div {
  width: 49%;
}

.widget_header {
  float: left;
  clear: both;
  width: 100%;
}

.dimension-wrapper.review_tab {
  float: left;
  width: 100%;
  clear: both;
}

.tab_color .field, .font-color .field, .prop_container.font-color {
  display: flex;
  align-items: center;
}

.prop_container.tab_color {
  display: inline-block;
  width: 21%;
  float: left;
}

.prop_container.tab_opacity .is-checkradio {
  display: inline-block;
}

.prop_container.tab_opacity .is-checkradio .field {
  width: 70px;
  margin-top: 5px;
}

.prop_container.font-color {
  display: inline-block;
  float: left;
  width: 17%;
}

.prop_container {
  margin: 22px 0 5px 0
}

.review_button_colors .field {
  display: flex;
  align-items: center;
}

.tab_color .field label, .font-color .field label, .review_button_colors .field label {
  margin-left: 10px;
}

.display_write_review_btn .is-checkradio {
  display: inline-block;
}
.display_write_review_btn .is-checkradio .field {
  width: 66px;
  display: inline-block;
}

.dropdown_widget .review_button_colors {
  width: 13% !important;
}
p.paragrph-style {
  padding-bottom: 5px !important;
}

.prop_container.review_button_colors {
  display: inline-block;
  width: 21%;
}

.prop_container.name_anonymous {
  display: inline-block;
  width: 49%;
}

.prop_container.num_of_reviews {
  width: 19%;
  margin-top: 14px;
  display: inline-block;
}

.name_anonymous .is-checkradio {
  display: inline-block;
}

.name_anonymous .is-checkradio .field {
  width: 66px;
  display: inline-block;
}

.field.star-rating-container .stars {
  margin-left: 15px
}

.field.star-rating-container label {
  margin-left: 15px !important;
  margin-right: 20px;
}
.fa-star {
  font-size: 10px !important;
}

.prop_container .tab_position {
  display: inline-block;
  width: 22%;
}

.widget_dimensions .prop_container {
  width: 21%;
  display: inline-block;
}

.field label {
  font-size: 12px
}

.verte__guide {
  width: 30px !important;
  height: 30px !important;
}

.verte {
  width: 30px !important;
  height: 30px !important;
  display: inline-block;
}


.star-rating-container {
  display: flex !important;
  align-items: center;
  margin: 12px 0px;
  width: auto !important;
}

button.verte__guide {
  height: 30px;
  width: 30px;
}

input.is-checkradio {
  display: inline-block
}

/* The container */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 14px;
  line-height: 17px;
  color: #707070;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  background-color: #30aae1;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 7px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}


.icon-container {
  width: 40px;
  display: inline-block;
  border: 1px solid #ccc;
  padding: 9px;
  background: #fff;
}

.disable-link {
  pointer-events: none;
}

.dummy-msg-holder:before {
  content: '!';
  position: absolute;
  display: block;
  width: 2px;
  height: 10px;
  color: #2faae1;
  left: 3%;
  font-size: 16px;
  font-weight: 600;
  top: 45%;
  transform: translateY(-50%);
}

.dummy-msg-holder:after {
  content: '';
  position: absolute;
  display: block;
  width: 1px;
  height: 100%;
  background: #2faae1;
  left: 7%;
  top: 0;
}

.dummy-msg-holder {
  border: 1px solid #2faae1;
  font-size: 12px;
  color: #2faae1;
  background: #f5fbfe;
  padding: 1.6% 2%;
  padding-left: 10%;
  position: relative;
  margin-bottom: 10px;
}

.desktop-icon {
  width: 60px;
  display: flex;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  padding: 9px;

}

.mob-icon {
  width: 60px;
  display: flex;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  padding: 9px;
}

#top-reviews-carousel {
  background: #fff;
  border: 1px solid #ccc;
  border-top: 1px solid #ccc !important;
  margin: auto auto 30px auto;
}

.right-side-container {
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  padding-bottom: 50px;
}

.full-width {
  width: 100%;
  float: left;
}

.top-info {
  border-bottom: 1px solid #ccc;
  padding: 22px 20px 0px 0;
  cursor: pointer;
  position: absolute;
  margin: -55px -2px 0 -20px;
  width: 83.5%;
}

.fr {
  text-align: right;
  right: 0;
  float: right;
  padding-right: 26px;
  width: 48%;
}

.fl {
  text-align: left;
  width: 48%;
  float: left;
  margin-left: 17px;
}

.mt-20 {
  margin-top: 20px;
}

.top-info a {
  width: 111px;
  height: 17px;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: #58595b;
}

.top-info .fr a img {
  margin-top: 5px;
}

.top-info .fr a span {
  margin-top: -12px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
}

.fa-arrow-left {
  color: #2aabe1;
}

a.blue {
  width: 168.4px;
  height: 15.2px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.27;
  letter-spacing: 0.55px;
  text-align: left;
  padding-top: 7px;
  font-size: 11px;
  color: #2aabe1;
  text-transform: uppercase;
}

.preview-com {
  background: #fff;
  margin: 80px 1px auto 1px !important;

}

.structure {
  padding-top: 20px;
}

.card-content > textarea {
  width: 100%;
  font-family: Monospace;
  border: none;
  color: #909ea9;
  background-color: #f5f5f5;
  resize: none;
  line-height: 1.5rem;
  padding: 20px;
  margin-top: 15px;
  font-size: 0.7rem;
  box-shadow: inset 0 0 5px #e7e7e7;
}

figure > img {
  border-radius: 0;
}

#back-to-results > a {
  text-decoration: none;
  color: #2aabe1;
}

iframe {
  border: 1px solid #CCCCCC;
  max-width: 100%;
  min-height: 200px;
  max-height: 200px;
}

.custom-dwonload-box h3 {
  font-weight: 600;
  margin-bottom: 10px;
}

.custom-dwonload-box .anchor {
  display: flex;
  margin-top: 50px;
}

.custom-dwonload-box .anchor a {
  cursor: pointer;
  color: #58595B;
}

.structure .heading-main {
  font-size: 16px;
  line-height: 24px;
  color: #58595b;
  font-weight: bold;
}

.structure .main-container {
  width: 100%;

}

.structure .main-container .md4 {
  width: 519px;
  margin: 0 15px;
  height: 708px;
}

.paragrph-style {
  padding-bottom: 20px;
  font-size: 12px;
  line-height: 17px;
  color: #707070;
}

.dimension-wrapper {
  margin: 18px 0;
}

.dimension-wrapper h4 {
  font-weight: bold;
  margin-bottom: 10px;
  border-bottom: 1px solid #dbdbdb;
  padding-bottom: 5px;
  font-size: 12px;
  line-height: 24px;
  color: #58595b;
}

.dimension-wrapper p {
  font-size: 12px;
  line-height: 17px;
  color: #707070;
}

.dimension-wrapper button {
  border: solid 1px #30a9e0;
  color: #30a9e0;
  font-size: 14px;
  line-height: 1.36;
  text-transform: uppercase;
  background-color: #ffffff;
  width: 180px;
  height: 40px;
  text-align: center;
}

.structure .main-container .md6 .dimension-wrapper a {
  color: #31aae1;
  font-size: 14px;
  line-height: 2.29;
}

.vertical-30 {
  overflow: auto;
  height: 90%;
  padding-bottom: 20px;
  padding-top: 20px;
}

.width-mob #top-reviews-widget {
  width: 100%;
}

input[type="checkbox"]:checked + label::after {
  content: '';
  position: absolute;
  width: 1.3ex;
  height: 0.6ex;
  background: #30aae1;
  top: .9ex;
  left: 0.5ex;
  border: 1.4px solid #fff;
  border-top: none;
  border-right: none;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

input[type="checkbox"] {
  line-height: 2.1ex;
}

input[type="checkbox"] {
  position: absolute;
  left: -999em;
}

input[type="checkbox"] + label {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  font-size: 12px !important;
}

input[type="checkbox"]:checked + label::before {
  content: "";
  display: inline-block;
  vertical-align: -25%;
  height: 2.5ex;
  width: 2.5ex;
  background-color: #30aae1;
  border: 1px solid #30aae1;
  border-radius: 1px;
  margin-right: 0.5em;
}

input[type="checkbox"] + label::before {
  content: "";
  display: inline-block;
  vertical-align: -25%;
  height: 2.5ex;
  width: 2.5ex;
  background-color: #fff;
  border: 1px solid #30aae1;
  border-radius: 1px;
  margin-right: 0.5em;
  margin-top: 7px;
}

.width-95 {
  width: 95%;
}

.fa, .far, .fas {
  font-family: "Font Awesome 5 Free";
}

@font-face {
  font-family: 'Font Awesome 5 Free';
  font-style: normal;
  font-weight: 400;
  src: url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.1.0/webfonts/fa-solid-900.woff2) format('woff2');
}

.Group-526 {
  width: 519px;
  height: 72px;
  object-fit: contain;
}

.carousel-dummy-text {
  width: 100%;
  border: solid 1px #30aae1;
  background-color: rgba(48, 170, 225, 0.05);
  font-family: OpenSans;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #30aae1;
  margin-bottom: 14px;
  display: inline-block;
  height: auto;
  padding: 1.2rem 3rem;
  position: relative;
}

.carousel-dummy-text:after {
  content: '!';
  color: #30aae1;
  font-size: 20px;
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.carousel-dummy-text:before {
  content: '';
  background: #30aae1;
  width: 1px;
  height: 100%;
  left: 2.3rem;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}

.responsive-action {
  display: none !important;
}

textarea#widget_header_text {
  resize: none;
  height: 25px !important;
  min-height: 53px;
  width: 226px !important;
  padding: 5px 10px;
  max-width: 226px !important;
  border: 1px solid #c9c9ca;
  color: #58595b;
  outline: none;
}

p.notice_max_char {
  color: #58595b !important;
  opacity: 0.6;
  margin-top: -3px;
  font-size: 10px !important;
  margin-left: 135px;
}

.right-side-container .header {
  min-height: 39.33px;
}

#hp-widget-hp-ctn-howItWorks p {
  display: inline-block;
  line-height: 9px;
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  font-size: 12px;
  height: 62.85px;
  width: 12px;
  top: 0px;
  position: relative;
}

#hp-widget-hp-ctn-howItWorks p span {
  position: absolute;
  color: #fff;
  position: absolute;
  margin-top: -14px;
  right: 2px;
}

.structure .main-container .md6 {
  min-width: 615px !important;
  margin: 0;
  float: left;
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.structure .main-container .md4 {
  width: 519px;
  margin: 0;
  height: 708px;
  float: left;
  display: inline-block;
}

main {
  padding-left: 15px !important;
  padding-right: 15px !important;
  overflow-x: auto !important;
}

.structure .main-container {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow-x: auto;
}

#num_of_reviews {
  border-color: #c9c9ca;
  font-size: 12px;
  border-radius: 0px;
  padding: 3px 40px 1px 12px;
  min-height: 35px;
  color: #58595b;
}

.select:has(#num_of_reviews)::after {
  right: 0.75em !important;
  border: 1.5px solid #58585b !important;
}

.num_of_reviews .select:not(.is-multiple)::after {
  border: 1px solid #58585b;
  border-right: 0px;
  border-top: 0px;
}

main.column.main-column {
  overflow: auto !important;
}

main.column.main-column .columns {
  overflow-x: visible;
}


.right-side-container .header {
  min-height: 39.33px;
}

#hp-widget-hp-ctn-howItWorks p {
  display: inline-block;
  line-height: 9px;
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  font-size: 12px;
  height: 62.85px;
  width: 12px;
  top: 0px;
  position: relative;
}

#hp-widget-hp-ctn-howItWorks p span {
  position: absolute;
  color: #fff;
  position: absolute;
  margin-top: -14px;
  right: 2px;
}
.showOnHover:hover>span {
  margin-top:-4px !important;
}
</style>
<style>
main {
  overflow: auto !important;
}

button.verte__guide {
  height: 30px;
  width: 30px;
}

.codeblock {
  display: block;
  pointer-events: none;
  user-select: none;
}

.width-mob #business-stats-widget img {
  width: 85px !important;
  position: relative !important;
  margin-top: initial !important;
  margin-left: inherit !important;
  float: right;
  margin-right: 16px !important;
  padding: 4px 0 5px 10px;
}

.width-mob .rating-stars-container {
  margin-top: 2px;
}

.width-mob .rating-stars-container ul li {
  font-size: 14px;
}

.width-mob #business-stats-widget > .left-block {
  font-size: 9px;
}

.right-side-container .header {
  justify-content: space-between;
  min-height: 55px !important;
}

.right-side-container .header h6 {
  display: flex;
  border: 2px solid #d3d3d3;
  border-radius: 5px;
  z-index: 99;
  position: relative;
}

.icon-container {
  width: 84px !important;
  height: 31px;
  padding: 0px !important;
}

.right-side-container .header h6 {
  background: #fff;
}

#business-stats-widget {
  font-size: 0.75rem;
}

.right-side-container .header h6 span.active {
  background: #8f9ea9;
}


#top-reviews-widget .is-mobile {
  display: block !important;
}

#top-reviews-widget .is-mobile .column.is-one-third {
  width: 100% !important;
  padding-bottom: 0;
}

#top-reviews-widget .is-mobile .has-text-right {
  text-align: left !important;
}

#top-reviews-widget .is-size-5 {
  font-size: 20px;
}

#top-reviews-widget {
  border-top: none !important;
}

#top-reviews-widget .column .has-text-weight-bold {
  font-size: 13px !important;
}

.width-mob-306 #top-reviews-carousel {
  width: 100% !important;
  height: auto !important;
  position: relative;
  padding-bottom: 70px !important;
}

.width-mob-306 .VueCarousel-slide {
  width: 100% !important;
}

#top-reviews-carousel {
  height: auto !important;
}

.width-mob-306 #top-reviews-carousel .level {
  display: block;
  padding-right: 2.1rem;
  padding-left: 2.1rem;
  margin-bottom: 0px;
}

.width-mob-306 #top-reviews-carousel .level .is-size-5 {
  display: block;
  font-size: 0.8rem !important;
}

.width-mob-306 #top-reviews-carousel .level .level-right {
  display: block;
  position: absolute;
  bottom: 26px;
}

.width-mob-306 #top-reviews-carousel hr {
  display: none;
}

.width-mob-306 #top-reviews-carousel .VueCarousel .columns:first-child .column {
  padding-bottom: 0px;
}

.width-mob-306 #top-reviews-carousel .VueCarousel .columns:first-child .column .reviews-widget {
  width: 100% !important;
  padding-bottom: 10px;
  border-bottom: 1px solid #cccccc;
}

.width-mob-306 #top-reviews-carousel .VueCarousel .columns:first-child .column h4 {
  font-size: 0.8rem;
}

#top-reviews-carousel .VueCarousel-slide > .columns:first-child {
  border-bottom: 0px !important;
}

.width-mob-306 #top-reviews-carousel .VueCarousel-slide > .columns:nth-child(2) > .column > p.author {
  padding-bottom: 15px;
  border-bottom: 1px solid #cccccc;
}

.VueCarousel .VueCarousel-navigation-button {
  color: #ffffff !important;
}

.VueCarousel .VueCarousel-navigation-button.VueCarousel-navigation-prev:before,
.VueCarousel .VueCarousel-navigation-button.VueCarousel-navigation-next:before {
  content: "<";
  position: absolute;
  top: 10px;
  left: 4px;
  color: #cccccc;
  font-size: 50px;
  height: 100%;
  width: 100%;
  display: inline-block;
  font-weight: 100;
}

.VueCarousel .VueCarousel-navigation-button.VueCarousel-navigation-next:before {
  content: ">";
  left: -4px;
}

#business-stats-widget {
  width: 402px !important;
}

.width-mob #business-stats-widget {
  width: 320px !important;
}

#business-stats-widget .rating-stars-container .business-widget {
  width: 180px !important;
}

#business-stats-widget img {
  width: 85px !important;
  float: right !important;
  margin-top: 10px;
  margin-left: 2px !important;
}

.heading-main-top {
  margin-top: -10px;
}

.structure .dimension-wrapper.dimension_box_first {
  margin-top: 0px;
  margin-bottom: 0px;
}

h3.heading-main.heading-main-top ~ p {
  padding-bottom: 25px;
}

.dimension_box_first .paragrph-style {
  padding-bottom: 0px;
}

.dimension-wrapper.dimension_box_first h4 {
  margin-bottom: 11px;
  line-height: 19px;
}

.left-side-container .dimension-wrapper.dimension_html_box {
  margin-top: 57px;
  margin-bottom: 10px;
}

.left-side-container .dimension-wrapper.dimension_download_box {
  margin: 0px;
}

.left-side-container .dimension-wrapper.dimension_download_box p {
  margin-bottom: 14px;
}

.left-side-container {
  width: 98%;
  border-right: 1px solid #dbdbdb;
  /* padding-right: 23px; */
  padding-top: 1px;
}

.preview_mainsection .preview-com {
  height: 100%;
  display: flex;
  align-items: center;
  background: transparent;
  margin-top: 0px !important;
}

.right-side-container.preview_mainsection {
  padding-bottom: 0px;
  display: flex;
  flex-direction: column;
}

.preview_mainsection .hero.image {
  background-color: #fff;
}

.mob-icon.active .mb1 {
  display: block;
}

.mob-icon.active .mb2 {
  display: none;
}

.mob-icon .mb1 {
  display: none;
}

span.desktop-icon.active .ds1 {
  display: block;
}

span.desktop-icon.active .ds2 {
  display: none;
}

span.desktop-icon .ds2 {
  display: block;
}

span.desktop-icon .ds1 {
  display: none;
}

.preview_white_bg div#top-reviews-widget {
  height: auto;
}

.preview_white_bg {
  width: 100%;
  background: #fff;
}

.preview_white_bg.review_top_slider {
  width: 100%;
  margin-top: 10%;
  height: 100%;
  background: #fff;
}


.preview_white_bg div#top-reviews-widget {
  height: auto;
  background: #fff;
  padding: 17px 20px 20px 20px;
}

.main-container-full.review_slider {
  padding-left: 1.5%;
  padding-right: 1.5%;
}

.review_slider .preview-com {
  width: 85%;
  max-width: 900px;
}

.preview_white_bg.review_top_slider {
  background: transparent;
}

img.download_img {
  margin-left: 5px;
}

.width-80 .preview_white_bg.review_top_slider #top-reviews-widget .is-mobile {
  display: flex !important;
  flex-direction: row;
}

#top-reviews-widget .is-mobile .column.is-one-third {
}

.width-80 .preview_white_bg.review_top_slider #top-reviews-widget .is-mobile div {
  padding-left: 0px;
  padding-right: 0px;
  width: auto !important;
}

.width-80 #top-reviews-widget .is-mobile .has-text-right {
  text-align: right !important;
}

div#top-reviews-carousel .VueCarousel-navigation-prev::before {
  background: url("/static/img/left-arrow-icon.png");
  background-repeat: no-repeat;
  content: '';
}

div#top-reviews-carousel .VueCarousel-navigation-next:before {
  background: url("/static/img/right-arrow-icon.png");
  background-repeat: no-repeat;
  content: '';
}

.dimension-wrapper.dimension_html_box a, .dimension-wrapper.dimension_html_box button, .dimension-wrapper button {
  cursor: pointer;
}

img.download_img ~ a {
  text-decoration: underline;
}

.width-85 {
  width: 425px;
}

div#top-reviews-carousel .VueCarousel-navigation-prev {
  transform: translateY(-165%) translateX(-100%);
}

div#top-reviews-carousel .VueCarousel-navigation-next {
  transform: translateY(-165%) translateX(100%);
}

.width-mob-306 div#top-reviews-carousel .VueCarousel-navigation-prev {
  transform: translateY(-22%) translateX(-100%);
}

.width-mob-306 div#top-reviews-carousel .VueCarousel-navigation-next {
  transform: translateY(-22%) translateX(100%);
}

.width-80 .preview_white_bg.review_top_slider #top-reviews-widget .is-mobile div {
  padding-left: 12px;
}

#top-reviews-widget > a {
  padding-top: 13px !important;
}

#top-reviews-widget > p {
  margin-left: 11px
}

.width-80-percent #top-reviews-carousel {
  height: auto !important;
  padding: 10px 30px !important;
  color: #58595B;
}

.width-80-percent #top-reviews-carousel hr {
  margin: 0px 39px 0px 35px
}

.width-80-percent #top-reviews-carousel .level-left {
  margin-left: 39px
}

.width-80-percent #top-reviews-carousel .level-right {
  margin-right: 39px
}

.width-80-percent #top-reviews-carousel .level:not(:last-child) {
  margin-bottom: 5px !important;
}

.width-80-percent #top-reviews-carousel .VueCarousel-slide > .columns[data-v-6fe7d8c2]:first-child {
  margin-bottom: -19px
}

.width-80-percent #top-reviews-carousel .VueCarousel-navigation-button {
  top: 61% !important;
}

#top-reviews-carousel h4 {
  font-size: 14px !important;
}

#top-reviews-carousel p.is-size-5 {
  font-size: 18px !important;
}

.width-mob-306 #top-reviews-carousel .level .is-size-5 {
  display: block;
  font-size: 14px !important;
}

.width-mob-306 #top-reviews-carousel h4 {
  display: block;
  font-size: 12px !important;
}

.width-mob-306 #top-reviews-carousel .VueCarousel-slide > .columns:nth-child(2) > .column > p {
  font-size: 10px !important;
}

#top-reviews-carousel a.external-link {
  text-decoration: underline !important;
}

/*  Star Rating  */
.width-85 .star-rating-widget .is-marginless {
  margin-bottom: -11px !important;
}

.width-85 .star-rating-widget {
  height: 174px !important;
}

.vertical-30 .preview_white_bg.review_top_slider {
  overflow-y: scroll;
  margin-top: 0px;
}

.preview-com.vertical-30 .column {
  margin-left: -.75rem;
  padding: 3px 19px 4px 13px;
}

.preview-com.vertical-30 #top-reviews-widget > p {
  margin-left: 0px;
}

.vertical-30 .preview_white_bg.review_top_slider {
  overflow-y: scroll;
  overflow-x: hidden;
}

.preview_white_bg.review_top_slider {
  width: 360px;
  max-width: 100%;
  margin: 0px auto;
}

.widget_dimensions .prop_container {
  margin-top: 1px;
}

.structure .main-container .md6 {
  width: calc(98% - 560px) !important;
  margin: 0 15px 0 0;
  float: left;
  display: inline-block;
  box-sizing: border-box;
}

.structure .main-container {
  width: 100%;
  display: inline-block;
}

.structure .main-container .md4 {
  width: 519px;
  margin: 0 15px;
  height: 708px;
  float: left;
  display: inline-block;
}

main {
  overflow-x: auto;
}
.cta_container {position: relative;}
.cta_container .dimension-wrapper.dimension_html_box {
  position: absolute;
  top: 0px;
  right: 0;
}
/* .vertical_feed_prop_section .dimension-wrapper .prop_container { vertical-align: top; } */
@media (min-width:1200px) and (max-width:1366px) {
  .v_feed_logo_color_container .is-checkradio.logo_color {
    width: 15% !important;
  }

  .v_feed_logo_color_container .is-checkradio.logo_color .is-checkradio.logo_color {
    width: 45% !important;
  }
  .vertical_feed_prop_section .prop_container.num_of_reviews {
    width: 25% !important;

  }
  .vertical_feed_prop_section .left-side-container .dimension-wrapper.dimension_html_box {
    margin-top: 85px !important;
  }

  .vertical_feed_prop_section .left-side-container .cta_container .dimension-wrapper.dimension_html_box {
    margin-top: 0px !important;
  }

  .v_feed_logo_color_container .logo_color {position: relative !important;}
  .v_feed_logo_color_container .is-checkradio.logo_color .is-info {vertical-align: top !important;}
}


@media (min-width:1024px) and (max-width:1200px) {
  .v_feed_logo_color_container .is-checkradio.logo_color {
    width: 20% !important;
  }

  .v_feed_logo_color_container .is-checkradio.logo_color .is-checkradio.logo_color {
    width: 45% !important;
  }
  .vertical_feed_prop_section .prop_container.num_of_reviews {
    width: 35% !important;

  }
  .vertical_feed_prop_section .left-side-container .dimension-wrapper.dimension_html_box {
    margin-top: 85px !important;
  }

  .vertical_feed_prop_section .left-side-container .cta_container .dimension-wrapper.dimension_html_box {
    margin-top: 0px !important;
  }

  .v_feed_logo_color_container .logo_color {position: relative !important;}
  .v_feed_logo_color_container .is-checkradio.logo_color .is-info {vertical-align: top !important;}
}

.cta_container .dimension-wrapper.dimension_html_box {
  position: absolute;
  top: 0px;
  margin: 0px !important;
  right: 0;
  top: 50%;
  margin-top: 0px !important;
  transform: translateY(-50%);
}

.cta_container .vertical_feed_prop_section .left-side-container .dimension-wrapper.dimension_html_box {
  margin-top: 0px !important;
}
.w_dimension .dimensions {
  padding: 3px 0px;
}
.color_label_holder {
  width:20px !important
}

.v_tab_num_of_reviews {
  width: 10%;
  margin-top: 14px;
  display: inline-block;
  min-width: 300px;
}
.left-side-container div.text-blue, .left-side-container a.blue-link {
  font-size: 12px;
}
div.mtop-0 {margin-top: 0px !important;}
.reviewSliderPreview .right-side-container.preview_mainsection {
  height: 700px !important;
}

.vertical_feed_preview.vertical_feed_preview_high.reviewSliderPreview .right-side-container.preview_mainsection {
  height: 700px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/onsite-widgets/WidgetDetails.vue